(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  (function () {
    var list = document.querySelector('[data-os-cart-list]');
    if (!list) return;

    var tokenEl = document.querySelector('[data-os-cart-token]');
    if (tokenEl) {
      fetch('/cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          tokenEl.textContent = (cart.token || '').slice(0, 8).toUpperCase() || 'n/a';
        })
        .catch(function () {
          tokenEl.textContent = 'n/a';
        });
    }

    // Random 6-digit "member number" — held in sessionStorage rather
    // than generated fresh in Liquid on every request, so a plain
    // page refresh keeps showing the same number for this visit;
    // opening the cart again in a new tab/session (sessionStorage is
    // per-tab) gets a new one, same idea as a new checkout getting
    // its own number.
    var memberNumberEl = document.querySelector('[data-os-member-number]');
    if (memberNumberEl) {
      var MEMBER_NUMBER_KEY = 'os_member_number';
      var memberNumber = null;
      try { memberNumber = sessionStorage.getItem(MEMBER_NUMBER_KEY); } catch (e) {}
      if (!memberNumber) {
        memberNumber = String(Math.floor(100000 + Math.random() * 900000));
        try { sessionStorage.setItem(MEMBER_NUMBER_KEY, memberNumber); } catch (e) {}
      }
      memberNumberEl.textContent = memberNumber;
    }

    // Simplest correct approach for a rebuild this size: change the
    // line via Shopify's own /cart/change.js, then reload so every
    // displayed price/subtotal/quantity across the page (including
    // the separate footer section) comes back freshly rendered from
    // the server, rather than hand-syncing each of those independently
    // in JS. Not as instant as Dawn's own AJAX-patched cart, but far
    // less code to get subtly wrong for a catalog this size.
    function changeLine(row, quantity) {
      var key = row.getAttribute('data-key');
      var errorEl = row.querySelector('[data-os-cart-error]');
      errorEl.hidden = true;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data && data.status) {
            errorEl.textContent = data.message || data.description || 'Couldn\'t update that item.';
            errorEl.hidden = false;
            return;
          }
          window.location.reload();
        })
        .catch(function () {
          errorEl.textContent = 'Couldn\'t update that item.';
          errorEl.hidden = false;
        });
    }

    list.querySelectorAll('[data-os-cart-row]').forEach(function (row) {
      var input = row.querySelector('[data-os-cart-qty-input]');
      var minus = row.querySelector('[data-os-cart-qty-minus]');
      var plus = row.querySelector('[data-os-cart-qty-plus]');
      var remove = row.querySelector('[data-os-cart-remove]');

      minus.addEventListener('click', function () {
        changeLine(row, Math.max(0, (parseInt(input.value, 10) || 0) - 1));
      });

      plus.addEventListener('click', function () {
        changeLine(row, (parseInt(input.value, 10) || 0) + 1);
      });

      input.addEventListener('change', function () {
        changeLine(row, Math.max(0, parseInt(input.value, 10) || 0));
      });

      remove.addEventListener('click', function () {
        changeLine(row, 0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["os-about"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.os-about__crossword');
    if (!root) return;

    // Entries 1-7 mostly keep their original hex colors; 3 (green) and
    // 4 (yellow) were darkened from their original neon values
    // (#39ff14, #ffea00) since both were too bright to read against
    // this light page background. 8-33 are hsl() neon colors spaced by
    // the golden angle (137.508deg) for good hue separation.
    var COLORS = {
      1: '#ff1744',
      2: '#2979ff',
      3: '#1e9e1e',
      4: '#b8860b',
      5: '#ff9100',
      6: '#b026ff',
      7: '#ff2fb0',
      8: 'hsl(20deg 100% 55%)',
      9: 'hsl(158deg 100% 55%)',
      10: 'hsl(295deg 100% 55%)',
      11: 'hsl(73deg 100% 55%)',
      12: 'hsl(210deg 100% 55%)',
      13: 'hsl(348deg 100% 55%)',
      14: 'hsl(125deg 100% 55%)',
      15: 'hsl(263deg 100% 55%)',
      16: 'hsl(40deg 100% 55%)',
      17: 'hsl(178deg 100% 55%)',
      18: 'hsl(315deg 100% 55%)',
      19: 'hsl(93deg 100% 55%)',
      20: 'hsl(230deg 100% 55%)',
      21: 'hsl(8deg 100% 55%)',
      22: 'hsl(145deg 100% 55%)',
      23: 'hsl(283deg 100% 55%)',
      24: 'hsl(60deg 100% 55%)',
      25: 'hsl(198deg 100% 55%)',
      26: 'hsl(335deg 100% 55%)',
      27: 'hsl(113deg 100% 55%)',
      28: 'hsl(250deg 100% 55%)',
      29: 'hsl(28deg 100% 55%)',
      30: 'hsl(165deg 100% 55%)',
      31: 'hsl(303deg 100% 55%)',
      32: 'hsl(80deg 100% 55%)',
      33: 'hsl(218deg 100% 55%)'
    };

    // 500 -> 250: "increase the color animation speed by 100%" means
    // twice as fast, i.e. half the duration per phrase.
    var AUTO_MS = 250;

    var cellEls = {};
    root.querySelectorAll('.os-about__crossword-char[data-cell]').forEach(function (el) {
      cellEls[el.getAttribute('data-cell')] = el;
    });

    // A cell can belong to two entries (an intersection). Tracking
    // which entries currently want it highlighted, rather than just a
    // boolean, means one entry's deactivate can't wipe out a highlight
    // a DIFFERENT still-active entry (autoplay and a manual hover, or
    // two crossing entries) is legitimately holding on that same cell.
    var activeBy = {};

    function restyle(cellKey) {
      var el = cellEls[cellKey];
      var active = activeBy[cellKey];
      if (!el || !active || !active.size) {
        if (el) {
          el.style.color = '';
          el.style.fontSize = '';
        }
        return;
      }
      var entryNum = Array.from(active).pop();
      el.style.color = COLORS[entryNum];
      el.style.fontSize = '1.7rem';
    }

    function hitInfo(hit) {
      return {
        entryNum: hit.getAttribute('data-entry'),
        cells: hit.getAttribute('data-cells').split(' ').filter(Boolean)
      };
    }

    function activateCells(entryNum, cells) {
      cells.forEach(function (c) {
        if (!activeBy[c]) activeBy[c] = new Set();
        activeBy[c].add(entryNum);
        restyle(c);
      });
    }

    function deactivateCells(entryNum, cells) {
      cells.forEach(function (c) {
        if (activeBy[c]) activeBy[c].delete(entryNum);
        restyle(c);
      });
    }

    // ---------- Autoplay: random cycle, one phrase at a time ----------
    var hitEls = Array.from(root.querySelectorAll('.os-about__crossword-hit'));
    var autoOrder = [];
    var autoIdx = 0;
    var autoTimer = null;
    var autoCurrent = null;
    var pausedByUser = false;

    function shuffle(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i];
        a[i] = a[j];
        a[j] = t;
      }
      return a;
    }

    function stepAuto() {
      if (pausedByUser) return;
      if (autoCurrent) {
        deactivateCells(autoCurrent.entryNum, autoCurrent.cells);
        autoCurrent = null;
      }
      if (autoIdx >= autoOrder.length) {
        // Freshly reshuffled every time the full set has cycled through
        // once, so "loop the animation" doesn't repeat the same order.
        autoOrder = shuffle(hitEls);
        autoIdx = 0;
      }
      var info = hitInfo(autoOrder[autoIdx]);
      autoIdx++;
      activateCells(info.entryNum, info.cells);
      autoCurrent = info;
      autoTimer = setTimeout(stepAuto, AUTO_MS);
    }

    function pauseAuto() {
      pausedByUser = true;
      if (autoTimer) {
        clearTimeout(autoTimer);
        autoTimer = null;
      }
      if (autoCurrent) {
        deactivateCells(autoCurrent.entryNum, autoCurrent.cells);
        autoCurrent = null;
      }
    }

    function resumeAuto() {
      pausedByUser = false;
      stepAuto();
    }

    // ---------- Manual hover/focus: pauses autoplay while active ----------
    hitEls.forEach(function (hit) {
      var info = hitInfo(hit);

      function activate() {
        pauseAuto();
        activateCells(info.entryNum, info.cells);
      }

      function deactivate() {
        deactivateCells(info.entryNum, info.cells);
        resumeAuto();
      }

      hit.addEventListener('mouseenter', activate);
      hit.addEventListener('mouseleave', deactivate);
      hit.addEventListener('focus', activate);
      hit.addEventListener('blur', deactivate);
    });

    // ---------- Entrance: letters fade in, randomized, over 2s ----------
    // Every letter is CSS-default opacity:0 (see component-os-ui.css);
    // this is what brings them in. Order is freshly reshuffled on
    // every load/reload, and each letter's own fade (LETTER_FADE_MS)
    // is short relative to the full window — their START times are
    // what's spread evenly across it, so at any moment several letters
    // are fading in at once rather than a rigid one-then-next-then-next
    // sequence, which is what actually reads as "one at a time" instead
    // of a single instant wipe across 456 letters.
    var ENTRANCE_MS = 2000;
    var LETTER_FADE_MS = 200;

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var allCells = shuffle(Object.values(cellEls));
      allCells.forEach(function (el, i) {
        var delay = allCells.length > 1
          ? (i / (allCells.length - 1)) * (ENTRANCE_MS - LETTER_FADE_MS)
          : 0;
        setTimeout(function () {
          el.style.opacity = '1';
        }, delay);
      });

      stepAuto();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["os-archive-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var gallery = document.querySelector('[data-os-archive-gallery]');
    if (!gallery) return;

    var slides = gallery.querySelectorAll('[data-os-archive-slide]');
    var captionGroups = gallery.querySelectorAll('[data-os-archive-caption-group]');
    var pageButtons = gallery.querySelectorAll('[data-os-archive-page]');

    // ---------- Letter-by-letter reveal (same technique as the about
    // page's crossword, scaled down: much less text per group here, so
    // a shorter window reads better than reusing the crossword's full
    // 2s/200ms). One combined shuffled pool per group — title and
    // description letters mixed together, not two separate reveals. ----------
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ENTRANCE_MS = 700;
    var LETTER_FADE_MS = 100;
    var START_DELAY_MS = ENTRANCE_MS * 0.3;

    function shuffle(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    }

    // Splits an element's text into one <span> per character (leaving
    // any existing <br> — the description's line breaks — untouched),
    // so each letter can be faded in independently. Each run of text
    // between <br>s (the title has exactly one; the description has
    // one per [bracket] line) is additionally wrapped in a
    // .os-archive-gallery__line span — the hover-enlarge unit, sized
    // with plain CSS :hover + a font-size transition so growing it
    // pushes the following lines down through normal block reflow,
    // animated smoothly frame-by-frame with no FLIP/JS needed. Returns
    // the flat list of letter spans in document order.
    function wrapLetters(el) {
      var letters = [];
      Array.from(el.childNodes).forEach(function (node) {
        if (node.nodeType !== Node.TEXT_NODE) return;
        var line = document.createElement('span');
        line.className = 'os-archive-gallery__line';
        Array.from(node.textContent).forEach(function (ch) {
          var span = document.createElement('span');
          span.className = 'os-archive-gallery__letter';
          span.textContent = ch;
          line.appendChild(span);
          letters.push(span);
        });
        node.parentNode.replaceChild(line, node);
      });
      return letters;
    }

    // A caption-group's "signature" is just its full text — two groups
    // with identical title+description (dnry/dnry, kurt/kurt, f-4/f-4)
    // get the same signature, which is exactly what "already revealed"
    // tracking below keys off of.
    var groupLetters = new Map();
    var groupSignatures = new Map();
    captionGroups.forEach(function (group) {
      groupSignatures.set(group, group.textContent);
      var titleEl = group.querySelector('.os-archive-gallery__caption');
      var descEl = group.querySelector('.os-archive-gallery__description');
      var letters = wrapLetters(titleEl).concat(wrapLetters(descEl));
      groupLetters.set(group, letters);
    });

    // Persists across the whole page view (not just immediate back-
    // and-forth) — navigating to a third image and back to one whose
    // exact text you've already seen revealed still skips the replay.
    var revealedSignatures = new Set();

    function revealGroup(group) {
      var letters = groupLetters.get(group);
      var signature = groupSignatures.get(group);

      if (reducedMotion || revealedSignatures.has(signature)) {
        letters.forEach(function (span) { span.style.opacity = '1'; });
        return;
      }

      revealedSignatures.add(signature);
      var shuffled = shuffle(letters);
      shuffled.forEach(function (span, i) {
        var delay = shuffled.length > 1
          ? (i / (shuffled.length - 1)) * (ENTRANCE_MS - LETTER_FADE_MS)
          : 0;
        setTimeout(function () { span.style.opacity = '1'; }, START_DELAY_MS + delay);
      });
    }

    // Initial page-load group (index 0, already rendered active).
    var initialGroup = gallery.querySelector('[data-os-archive-caption-group].is-active');
    if (initialGroup) revealGroup(initialGroup);

    // ---------- Magnifying-glass hover lens ----------
    // A single fixed-position circle, reused across every image, that
    // follows the cursor and shows a 3x zoomed crop of whatever's under
    // it — panning clamped so it only ever shows real photo content,
    // never blank space past an edge (same clamp-to-bounds idea as the
    // mood page's edge-scroll work, applied to background-position
    // instead of scroll offset).
    var LENS_SIZE = 200; // px — 20rem at this theme's fixed 10px root font-size
    var ZOOM = 3;

    var lens = document.createElement('div');
    lens.className = 'os-archive-gallery__lens';
    document.body.appendChild(lens);

    function hideLens() {
      lens.style.display = 'none';
    }

    function attachLens(img) {
      function move(e) {
        var rect = img.getBoundingClientRect();
        var x = Math.max(0, Math.min(rect.width, e.clientX - rect.left));
        var y = Math.max(0, Math.min(rect.height, e.clientY - rect.top));

        var bgWidth = rect.width * ZOOM;
        var bgHeight = rect.height * ZOOM;
        var bgX = Math.min(0, Math.max(-(bgWidth - LENS_SIZE), -(x * ZOOM - LENS_SIZE / 2)));
        var bgY = Math.min(0, Math.max(-(bgHeight - LENS_SIZE), -(y * ZOOM - LENS_SIZE / 2)));

        lens.style.backgroundImage = 'url(' + img.currentSrc + ')';
        lens.style.backgroundSize = bgWidth + 'px ' + bgHeight + 'px';
        lens.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
        lens.style.left = e.clientX + 'px';
        lens.style.top = e.clientY + 'px';
        lens.style.display = 'block';
      }

      img.addEventListener('mouseenter', function (e) {
        img.style.cursor = 'none';
        move(e);
      });
      img.addEventListener('mousemove', move);
      img.addEventListener('mouseleave', function () {
        img.style.cursor = '';
        hideLens();
      });
    }

    gallery.querySelectorAll('.os-archive-gallery__frame img').forEach(attachLens);

    pageButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = Number(button.getAttribute('data-os-archive-page'));

        slides.forEach(function (slide, i) {
          slide.hidden = i !== index;
          slide.classList.toggle('is-active', i === index);
        });

        captionGroups.forEach(function (group, i) {
          group.hidden = i !== index;
          group.classList.toggle('is-active', i === index);
          if (i === index) revealGroup(group);
        });

        pageButtons.forEach(function (btn, i) {
          btn.classList.toggle('is-active', i === index);
          btn.setAttribute('aria-current', i === index ? 'true' : 'false');
        });

        hideLens();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["os-collection-index"]) return;
  try {
    
  /* ---------- Shared fade-swap helper (checkout pilot collection only) ----------
     Both the thumbnail click and the variant-driven photo swap below
     change the same .os-collection-index__media <img> — this is the
     one place that actually touches its src, so both call through it
     rather than each doing their own instant swap. Fades the current
     photo out, swaps the attributes once it's invisible, then fades
     the new one in — a clean crossfade instead of a hard cut. Skips
     the fade for prefers-reduced-motion (swaps instantly instead of
     animating opacity). */
  var osCollectionReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var OS_COLLECTION_FADE_MS = 180;

  function osCollectionSwapMainImage(mainImg, attrs) {
    function setAttrs() {
      mainImg.src = attrs.src;
      mainImg.alt = attrs.alt || '';
      mainImg.width = attrs.width;
      mainImg.height = attrs.height;
    }

    if (osCollectionReducedMotion) {
      setAttrs();
      return;
    }

    mainImg.style.transition = 'opacity ' + OS_COLLECTION_FADE_MS + 'ms ease';
    mainImg.style.opacity = '0';
    setTimeout(function () {
      setAttrs();
      mainImg.style.opacity = '1';
    }, OS_COLLECTION_FADE_MS);
  }

  /* ---------- Thumbnail swap (checkout pilot collection only) ----------
     Clicking a thumbnail swaps the <img> inside .os-collection-index__media
     in place — no separate "current photo" state to track, since the
     click-to-preview script below always reads whatever img is
     actually inside that button at the moment it's clicked. No-ops if
     this collection has no thumbnail strip at all (every other
     collection, or a single-image product on this one). */
  (function () {
    var thumbLists = document.querySelectorAll('[data-os-collection-thumbs]');
    if (!thumbLists.length) return;

    thumbLists.forEach(function (list) {
      /* The thumbnail <ul> is always .os-collection-index__media's
         next sibling inside .media-col (see the section template). */
      var media = list.previousElementSibling;
      var mainImg = media ? media.querySelector('img') : null;
      if (!media || !mainImg) return;

      var thumbs = list.querySelectorAll('[data-os-collection-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          osCollectionSwapMainImage(mainImg, {
            src: thumb.getAttribute('data-full-src'),
            alt: thumb.getAttribute('data-full-alt'),
            width: thumb.getAttribute('data-full-width'),
            height: thumb.getAttribute('data-full-height')
          });

          thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        });
      });
    });
  })();

  /* ---------- Variant photo swap (checkout pilot collection only) ----------
     Selecting Black should show the black photo, White the white one,
     etc. — keyed off each variant's own title (Shopify's canonical
     "Value1 / Value2" join), built server-side into a JSON map
     alongside the picker (see the section template). Joining the
     currently-checked radios the same way client-side is what makes
     the lookup line up with zero guessing about which option is
     "Color" — this works for however many options a product has. */
  (function () {
    var variantSelects = document.querySelectorAll('[id^="variant-selects-"]');
    if (!variantSelects.length) return;

    function parseJsonScript(root, attr) {
      var el = root.querySelector('[' + attr + ']');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }

    variantSelects.forEach(function (root) {
      var imagesByVariantTitle = parseJsonScript(root, 'data-os-collection-variant-images') || {};
      var idsByVariantTitle = parseJsonScript(root, 'data-os-collection-variant-ids') || {};

      var item = root.closest('.os-collection-index__item');
      var mainImg = item ? item.querySelector('.os-collection-index__media img') : null;
      var thumbs = item ? item.querySelectorAll('[data-os-collection-thumb]') : [];
      // Both buy-buttons' own hidden id field and its submit button
      // live in .os-collection-index__buy, a sibling of .os-collection-index__checkout
      // (which is where `root`/variant-selects itself sits) — not a
      // descendant of root, so this has to be found via the shared
      // .os-collection-index__item ancestor instead of root.querySelector.
      var idInput = item ? item.querySelector('input[name="id"]') : null;
      var submitButton = item ? item.querySelector('.os-collection-index__buy [type="submit"]') : null;

      function currentVariantTitle() {
        var values = [];
        root.querySelectorAll('fieldset').forEach(function (fieldset) {
          var checked = fieldset.querySelector('input:checked');
          if (checked) values.push(checked.value);
        });
        return values.join(' / ');
      }

      function applyImage(img) {
        if (!img || !mainImg) return;
        osCollectionSwapMainImage(mainImg, img);
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-full-src') === img.src);
        });
      }

      // The actual fix: without this, buy-buttons' hidden id input
      // stayed pinned to whatever variant was selected/first-available
      // at page load (e.g. Small) forever — every Add to cart click
      // submitted that same variant regardless of what Size/Color
      // were actually highlighted on screen.
      function applyVariantId(variant) {
        if (!variant || !idInput) return;
        idInput.value = variant.id;
        if (submitButton) {
          submitButton.disabled = !variant.available;
          submitButton.setAttribute('aria-disabled', String(!variant.available));
          // Label follows availability the same way the product page's
          // own button does ("Sold out" vs "Add to cart"), instead of a
          // greyed-out "Add to cart" on sold-out sizes.
          var label = submitButton.querySelector('span');
          if (label && window.variantStrings) {
            label.textContent = variant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
          }
        }
      }

      // Price line follows the picked variant (price.liquid's own
      // markup: .price__regular for full price, .price__sale with the
      // struck-through compare-at when .price--on-sale is set).
      var priceEl = item ? item.querySelector('.os-collection-index__price .price') : null;
      function applyPrice(variant) {
        if (!variant || !priceEl || !variant.price) return;
        priceEl.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach(function (el) {
          el.textContent = variant.price;
        });
        var compareEl = priceEl.querySelector('.price__sale s.price-item--regular');
        if (compareEl && variant.compare) compareEl.textContent = variant.compare;
        priceEl.classList.toggle('price--on-sale', !!variant.onSale);
        priceEl.classList.toggle('price--sold-out', !variant.available);
      }

      root.addEventListener('change', function () {
        var title = currentVariantTitle();
        applyImage(imagesByVariantTitle[title]);
        applyVariantId(idsByVariantTitle[title]);
        applyPrice(idsByVariantTitle[title]);
      });
    });
  })();

  /* ---------- Click-to-preview (checkout pilot collection only) ----------
     Same shared-backdrop-plus-image device as the mood page's own
     click-to-preview (os-mood.liquid): one reused overlay, its
     position/size written by JS at click/close time, animating from
     the clicked photo's own on-page rect out to a centered box. Not
     gated behind (hover: hover)/(pointer: fine) since this replaces
     what used to be a real navigable link — it needs a touch
     equivalent too, same reasoning as the mood page's own version.
     No-ops immediately if this collection's preview markup isn't on
     the page at all (every other Shop collection still just links out
     to product.url and never renders any of this). */
  (function () {
    var root = document.querySelector('[data-os-collection-preview-root]');
    var backdrop = document.querySelector('[data-os-collection-preview-backdrop]');
    var img = document.querySelector('[data-os-collection-preview-img]');
    var triggers = document.querySelectorAll('[data-os-collection-preview]');
    if (!root || !backdrop || !img || !triggers.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var PREVIEW_MS = reducedMotion ? 0 : 450;
    var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
    var MAX_VW = 0.64;
    var MAX_VH = 0.64;

    var activeTrigger = null;
    var closeTimer = null;

    function sourcePhoto(trigger) {
      return trigger.querySelector('img');
    }

    function targetRectFor(photo) {
      var maxWidth = window.innerWidth * MAX_VW;
      var maxHeight = window.innerHeight * MAX_VH;
      var nw = photo.naturalWidth || maxWidth;
      var nh = photo.naturalHeight || maxHeight;
      var scale = Math.min(maxWidth / nw, maxHeight / nh);
      var width = nw * scale;
      var height = nh * scale;
      return {
        left: (window.innerWidth - width) / 2,
        top: (window.innerHeight - height) / 2,
        width: width,
        height: height
      };
    }

    function setImgRect(rect) {
      img.style.transition = 'none';
      img.style.left = rect.left + 'px';
      img.style.top = rect.top + 'px';
      img.style.width = rect.width + 'px';
      img.style.height = rect.height + 'px';
    }

    /* Same FLIP shape as the mood page's version: pin the true
       starting rect with transitions off, force a layout flush, then
       switch the transition on and write the real target. */
    function animateTo(rect, durationMs) {
      img.style.transition = 'none';
      void img.offsetWidth;
      img.style.transition = 'left ' + durationMs + 'ms ' + EASING + ', top ' + durationMs + 'ms ' + EASING + ', width ' + durationMs + 'ms ' + EASING + ', height ' + durationMs + 'ms ' + EASING;
      img.style.left = rect.left + 'px';
      img.style.top = rect.top + 'px';
      img.style.width = rect.width + 'px';
      img.style.height = rect.height + 'px';
    }

    function lockScroll() {
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.overflow = 'hidden';
      if (scrollbarWidth > 0) document.body.style.paddingRight = scrollbarWidth + 'px';
    }

    function unlockScroll() {
      document.documentElement.style.overflow = '';
      document.body.style.paddingRight = '';
    }

    function openPreview(trigger) {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      activeTrigger = trigger;

      var photo = sourcePhoto(trigger);
      var startRect = photo.getBoundingClientRect();
      img.src = photo.currentSrc || photo.src;
      img.alt = photo.alt || '';

      root.hidden = false;
      lockScroll();

      setImgRect(startRect);
      void img.offsetWidth;

      backdrop.style.transition = 'none';
      backdrop.style.opacity = '0';
      void backdrop.offsetWidth;
      backdrop.style.transition = 'opacity ' + PREVIEW_MS + 'ms ' + EASING;
      backdrop.style.opacity = '1';

      animateTo(targetRectFor(photo), PREVIEW_MS);
    }

    function closePreview() {
      if (!activeTrigger || root.hidden) return;
      var photo = sourcePhoto(activeTrigger);
      var endRect = photo.getBoundingClientRect();

      backdrop.style.transition = 'opacity ' + PREVIEW_MS + 'ms ' + EASING;
      backdrop.style.opacity = '0';
      animateTo(endRect, PREVIEW_MS);

      unlockScroll();

      activeTrigger = null;
      closeTimer = setTimeout(function () {
        root.hidden = true;
        img.src = '';
        closeTimer = null;
      }, PREVIEW_MS);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openPreview(trigger);
      });
    });

    backdrop.addEventListener('click', closePreview);
    img.addEventListener('click', closePreview);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) closePreview();
    });

    window.addEventListener('resize', function () {
      if (activeTrigger && !root.hidden) {
        animateTo(targetRectFor(sourcePhoto(activeTrigger)), 0);
      }
    }, { passive: true });
  })();

  // ---------- Description letter-shuffle reveal ----------
  // Same technique as the archive page's own photo descriptions
  // (os-archive-gallery.liquid's own wrapLetters/revealGroup) — letters
  // wrapped in spans, shuffled, and faded in over a short staggered
  // window — rather than the plain os-load-in fade+rise used for most
  // other page-load content. Ported as a single-shot version (no
  // caption-group cycling to track here, just the one description).
  (function () {
    var descEl = document.querySelector('[data-os-collection-description]');
    if (!descEl) return;

    var ENTRANCE_MS = 700;
    var LETTER_FADE_MS = 100;
    var START_DELAY_MS = ENTRANCE_MS * 0.3;

    function shuffle(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    }

    function wrapLetters(el) {
      var letters = [];
      Array.from(el.childNodes).forEach(function (node) {
        if (node.nodeType !== Node.TEXT_NODE) return;
        var line = document.createElement('span');
        line.className = 'os-archive-gallery__line';
        Array.from(node.textContent).forEach(function (ch) {
          var span = document.createElement('span');
          span.className = 'os-archive-gallery__letter';
          span.textContent = ch;
          line.appendChild(span);
          letters.push(span);
        });
        node.parentNode.replaceChild(line, node);
      });
      return letters;
    }

    var letters = wrapLetters(descEl);

    if (osCollectionReducedMotion) {
      letters.forEach(function (span) { span.style.opacity = '1'; });
      return;
    }

    var shuffled = shuffle(letters);
    shuffled.forEach(function (span, i) {
      var delay = shuffled.length > 1
        ? (i / (shuffled.length - 1)) * (ENTRANCE_MS - LETTER_FADE_MS)
        : 0;
      setTimeout(function () { span.style.opacity = '1'; }, START_DELAY_MS + delay);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["os-gashapon"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-os-gashapon]');
    if (!root) return;

    // ---------- Vending machine product colors ----------
    // Same 33-color palette the about page's crossword uses (see
    // os-about.liquid) — duplicated here rather than shared, since
    // this theme's sections are each self-contained with no shared JS
    // module to pull a constant like this from. Shuffled and the
    // first 21 handed out to the vending machine's 21 product slots
    // fresh on every load, rather than a fixed assignment — so it
    // never looks the same way twice, the same spirit as the
    // crossword's own randomized entrance order (though that
    // randomizes reveal order, not color-to-entry assignment, since
    // colors there are fixed per phrase; here there's no equivalent
    // "identity" per slot to keep fixed, so shuffling the assignment
    // itself is the equivalent gesture).
    var VENDING_COLORS = [
      '#ff1744', '#2979ff', '#1e9e1e', '#b8860b', '#ff9100', '#b026ff', '#ff2fb0',
      'hsl(20deg 100% 55%)', 'hsl(158deg 100% 55%)', 'hsl(295deg 100% 55%)',
      'hsl(73deg 100% 55%)', 'hsl(210deg 100% 55%)', 'hsl(348deg 100% 55%)',
      'hsl(125deg 100% 55%)', 'hsl(263deg 100% 55%)', 'hsl(40deg 100% 55%)',
      'hsl(178deg 100% 55%)', 'hsl(315deg 100% 55%)', 'hsl(93deg 100% 55%)',
      'hsl(230deg 100% 55%)', 'hsl(8deg 100% 55%)', 'hsl(145deg 100% 55%)',
      'hsl(283deg 100% 55%)', 'hsl(60deg 100% 55%)', 'hsl(198deg 100% 55%)',
      'hsl(335deg 100% 55%)', 'hsl(113deg 100% 55%)', 'hsl(250deg 100% 55%)',
      'hsl(28deg 100% 55%)', 'hsl(165deg 100% 55%)', 'hsl(303deg 100% 55%)',
      'hsl(80deg 100% 55%)', 'hsl(218deg 100% 55%)'
    ];

    // A separate, muted/darker palette just for the vending machines'
    // own product items — same 33-hue spacing as VENDING_COLORS above
    // (so the two still feel related), but saturation dropped from
    // 100% to 45% and lightness from 55% to 32% for a duller, less
    // neon look. Kept as its own array rather than editing
    // VENDING_COLORS in place because that array is also where the
    // gachapon dome balls' own red/blue/orange get pulled from (see
    // GASHA_CAP_COLORS below) — this way the item recolor only touches
    // the vending machines, not the balls.
    var VENDING_ITEM_COLORS = [
      '#8a3b3b', '#3d5a80', '#3e6b3e', '#7a611c', '#a3671f', '#6b4c8a', '#a15c7a',
      'hsl(20deg 45% 32%)', 'hsl(158deg 45% 32%)', 'hsl(295deg 45% 32%)',
      'hsl(73deg 45% 32%)', 'hsl(210deg 45% 32%)', 'hsl(348deg 45% 32%)',
      'hsl(125deg 45% 32%)', 'hsl(263deg 45% 32%)', 'hsl(40deg 45% 32%)',
      'hsl(178deg 45% 32%)', 'hsl(315deg 45% 32%)', 'hsl(93deg 45% 32%)',
      'hsl(230deg 45% 32%)', 'hsl(8deg 45% 32%)', 'hsl(145deg 45% 32%)',
      'hsl(283deg 45% 32%)', 'hsl(60deg 45% 32%)', 'hsl(198deg 45% 32%)',
      'hsl(335deg 45% 32%)', 'hsl(113deg 45% 32%)', 'hsl(250deg 45% 32%)',
      'hsl(28deg 45% 32%)', 'hsl(165deg 45% 32%)', 'hsl(303deg 45% 32%)',
      'hsl(80deg 45% 32%)', 'hsl(218deg 45% 32%)'
    ];

    // Each of the 21 slots picks its own random shape on load (mixed
    // freely within a row, not locked to one shape per row) — bottle
    // and can and bag are the original 3, circle and a flat rectangular
    // bar are new, for the "more realistic, more varied" look asked
    // for. Every shape's own colorable piece keeps the same
    // os-gashapon__vending-item class + data-vending-item attribute the
    // color step below already looks for, regardless of which shape
    // that turned out to be.
    var VENDING_SHAPES = [
      function bottle() {
        return '<rect class="os-gashapon__vending-item" data-vending-item x="-5" y="8" width="10" height="22" rx="2"></rect>' +
          '<rect x="-3" y="2" width="6" height="6"></rect>';
      },
      function can() {
        return '<rect class="os-gashapon__vending-item" data-vending-item x="-5" y="6" width="10" height="26" rx="1"></rect>';
      },
      function bag() {
        return '<rect class="os-gashapon__vending-item" data-vending-item x="-5" y="8" width="10" height="22" rx="2"></rect>' +
          '<line x1="-5" y1="13" x2="5" y2="13"></line>';
      },
      function circle() {
        return '<circle class="os-gashapon__vending-item" data-vending-item cx="0" cy="18" r="7"></circle>';
      },
      function bar() {
        return '<rect class="os-gashapon__vending-item" data-vending-item x="-6" y="16" width="12" height="10" rx="1"></rect>';
      }
    ];

    // Shapes and colors both reassign fresh on every load, and
    // independently PER MACHINE — each of the 3 vending machines on
    // this page (1 left, 2 right — see the liquid template) runs its
    // own shuffle over just its own 21 slots, rather than one shuffle
    // shared/split across all 3, so no single machine's own look is
    // ever influenced by however the others happened to randomize.
    root.querySelectorAll('[data-vending-machine]').forEach(function (machine) {
      var slots = machine.querySelectorAll('[data-vending-slot]');
      if (!slots.length) return;

      slots.forEach(function (slot) {
        var shapeGroup = slot.querySelector('[data-vending-item-shape]');
        var shapeFn = VENDING_SHAPES[Math.floor(Math.random() * VENDING_SHAPES.length)];
        shapeGroup.innerHTML = shapeFn();
      });

      var items = machine.querySelectorAll('[data-vending-item]');
      var shuffled = VENDING_ITEM_COLORS.slice();
      for (var i = shuffled.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = shuffled[i]; shuffled[i] = shuffled[j]; shuffled[j] = t;
      }

      items.forEach(function (item, i) {
        var color = shuffled[i % shuffled.length];
        item.style.fill = color;
        // Also set as the CSS color property (unused for painting the
        // shape itself, which uses fill) purely so the hover glow in
        // the stylesheet can reference it via currentColor and match
        // each item's own randomized hue, rather than a single flat
        // glow color shared by all 21 slots.
        item.style.color = color;

        // Idle flicker (see component-os-gashapon.css's own
        // @keyframes os-gashapon-vending-flicker): every item shares
        // the same 18s keyframe shape (half speed of the original 9s —
        // slowed down on request), but a random NEGATIVE delay starts
        // each one already partway through its own cycle instead of
        // all 21+ items launching in visible unison at page load, and
        // a slightly randomized duration (16-20s) makes them drift
        // further apart from each other over time even if two happened
        // to start close together.
        var duration = 16 + Math.random() * 4;
        item.style.setProperty('--flicker-duration', duration.toFixed(2) + 's');
        item.style.setProperty('--flicker-delay', (-Math.random() * duration).toFixed(2) + 's');
      });
    });

    // ---------- Vending machine marquee ----------
    // All 4 machines share ONE identical deck/order of messages (built
    // once below, not reshuffled per machine) rather than 4
    // independent shuffles of the same small pool -- with only 4
    // tracks drawing from just 6-7 shared phrases, independent
    // randomness (what this used to do) couldn't actually guarantee
    // two machines never show the same text at once, only make it
    // unlikely. Instead, every machine scrolls through the exact same
    // deck at the exact same speed, just phase-shifted by exactly 1/4
    // of the deck's own total width -- like 4 cars evenly spaced around
    // one circular track. Since all 4 are always looking at a
    // different quarter of the identical deck, they can only ever show
    // the same text at the same time if two DIFFERENT deck entries
    // happen to be identical AND land less than 1/4 of the deck's
    // width apart -- which is exactly why "feeling lucky?" (deliberately
    // repeated twice, per earlier request) is placed at fixed anchor
    // points roughly half the deck apart below instead of wherever a
    // random shuffle happens to drop it, and why 2 extra phrases from
    // the about page's own crossword entries (see os-about.liquid) pad
    // the deck out -- enough real distinct content that the two
    // "feeling lucky?" anchors land comfortably past that 1/4-width
    // danger zone, while the original 6 messages still make up the
    // large majority of what's actually on screen.
    var MARQUEE_HALF_1 = ['TRY YOUR LUCK!', 'GOOD LUCK :)', '1-800-LUCKY'];
    var MARQUEE_HALF_2 = ['PULL THE LEVER!', 'SPIN TO WIN!', 'CRAFTED WITH LOVE', 'LIFE IS BEAUTIFUL'];
    function shuffleInPlace(arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
      }
      return arr;
    }
    var marqueeDeck = ['FEELING LUCKY?']
      .concat(shuffleInPlace(MARQUEE_HALF_1.slice()))
      .concat(['FEELING LUCKY?'])
      .concat(shuffleInPlace(MARQUEE_HALF_2.slice()));
    var marqueeText = marqueeDeck.join('              ');
    var marqueeDuration = null;
    // Real screen px/s, not SVG user units. Every machine's marquee
    // moves at the same visual pace regardless of how long its own
    // shuffled message sequence happens to be, since the animation's
    // own duration (set below) is derived from each track's actual
    // rendered width at this speed.
    var MARQUEE_SPEED_PX_S = 30;

    root.querySelectorAll('[data-vending-marquee-track]').forEach(function (track, index, tracks) {
      var first = document.createElement('span');
      first.className = 'os-gashapon__vending-marquee-text';
      first.textContent = marqueeText;
      track.appendChild(first);
      track.appendChild(first.cloneNode(true));
      if (marqueeDuration == null) {
        var singleWidth = first.getBoundingClientRect().width;
        marqueeDuration = singleWidth > 0 ? singleWidth / MARQUEE_SPEED_PX_S : 9;
      }
      track.style.setProperty('--marquee-duration', marqueeDuration.toFixed(2) + 's');
      var delay = (index / tracks.length) * marqueeDuration;
      track.style.setProperty('--marquee-delay', (-delay).toFixed(2) + 's');
    });

    // ---------- Dome ball / capsule colors ----------
    // Restricted to just the palette's own red/blue/orange (the first,
    // second, and fifth entries of VENDING_COLORS) rather than the
    // full 33 — only their SLOT order reshuffles fresh each load, not
    // which 3 colors are in play. Written into the --gasha-cap-1/2/3
    // custom properties (:root's own fixed defaults live in
    // component-os-gashapon.css). Every ball's cap already references
    // one of those 3 vars via its existing
    // os-gashapon__dome-cap-lid--{1,2,3} class and the 3-way modulo
    // assignment in the loop above, so overriding just the custom
    // properties recolors all 15 balls without touching the SVG
    // markup or that assignment at all. capsuleColors (used below for
    // whichever ball's color rides along with the ejected
    // capsule/ticket) becomes these same 3.
    var GASHA_CAP_COLORS = [VENDING_COLORS[0], VENDING_COLORS[1], VENDING_COLORS[4]]; // red, blue, orange
    var capsuleColors = (function pickCapColors() {
      var shuffled = GASHA_CAP_COLORS.slice();
      for (var i = shuffled.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = shuffled[i]; shuffled[i] = shuffled[j]; shuffled[j] = t;
      }
      root.style.setProperty('--gasha-cap-1', shuffled[0]);
      root.style.setProperty('--gasha-cap-2', shuffled[1]);
      root.style.setProperty('--gasha-cap-3', shuffled[2]);
      return shuffled;
    })();

    var STORAGE_KEY = 'gashapon_play_v1';
    var replayDaysAttr = parseInt(root.getAttribute('data-replay-days'), 10);
    var replayDays = isNaN(replayDaysAttr) ? 30 : replayDaysAttr;
    var soundDefault = root.getAttribute('data-sound-default') === 'true';

    var stage = root.querySelector('[data-gashapon-stage]');
    var groundEl = root.querySelector('.os-gashapon__ground');
    var leverButton = root.querySelector('[data-gashapon-lever]');
    var leverPivot = root.querySelector('[data-gashapon-lever-pivot]');
    var capsule = root.querySelector('[data-gashapon-capsule]');
    var capsuleTop = root.querySelector('.os-gashapon__capsule-top');
    var capsuleBottom = root.querySelector('.os-gashapon__capsule-bottom');
    // Set once animateRoll's post-roll bounce becomes a permanent idle
    // loop (see animateRoll below) so armOpenHandler can cancel it the
    // moment the capsule is tapped open.
    var capsuleWobbleRafId = null;
    var status = root.querySelector('[data-gashapon-status]');
    var ticket = root.querySelector('[data-gashapon-ticket]');
    var ticketWiggle = root.querySelector('[data-gashapon-ticket-wiggle]');
    var ticketFlip = root.querySelector('[data-gashapon-ticket-flip]');
    var ticketBack = root.querySelector('[data-gashapon-ticket-back]');
    var ticketPrompt = root.querySelector('[data-gashapon-ticket-prompt]');
    var lockedPanel = root.querySelector('[data-gashapon-locked]');
    var lockedDate = root.querySelector('[data-locked-date]');
    var lockedTicket = root.querySelector('[data-gashapon-locked-ticket]');
    var lockedTicketBack = root.querySelector('[data-gashapon-locked-ticket-back]');
    var viewAgainButton = root.querySelector('[data-gashapon-view-again]');
    var soundToggle = root.querySelector('[data-gashapon-sound-toggle]');
    var soundLabel = root.querySelector('[data-sound-label]');
    var prizesScript = root.querySelector('[data-gashapon-prizes]');

    var prizes = [];
    try {
      prizes = JSON.parse(prizesScript.textContent).filter(function (p) {
        return p && p.label;
      });
    } catch (e) {
      prizes = [];
    }

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var storedSound = null;
    try { storedSound = localStorage.getItem('gashapon_sound'); } catch (e) {}
    var soundEnabled = storedSound ? storedSound === 'on' : soundDefault;
    var pending = false;
    var audioCtx = null;

    // ---------- Basement lighting ----------
    // Dims the whole page after load, then drops a single lightbulb on
    // a cord above the gachapon machine with spring-driven bounce +
    // pendulum sway, and cuts a real triangular reveal for it into the
    // dark overlay via a live-updated SVG mask polygon. See the liquid
    // template's own comments for why the reveal is a real mask rather
    // than a glow layered on top, and why .os-gashapon__machine-frame
    // was shrunk 30% to make room for the lamp above it.
    var dimOverlay = root.querySelector('[data-gashapon-dim]');
    var maskBg = root.querySelector('[data-gashapon-dim-mask-bg]');
    var maskBeam = root.querySelector('[data-gashapon-dim-beam]');
    var lampPivot = root.querySelector('[data-gashapon-lamp]');
    var lampCord = root.querySelector('[data-gashapon-lamp-cord]');
    var lampBulb = root.querySelector('[data-gashapon-lamp-bulb]');

    if (dimOverlay && lampPivot) {
      // Short and fixed rather than computed from viewport/page
      // geometry — the pivot already sits just below the header (see
      // .os-gashapon__lamp-pivot's own CSS), and the bulb should only
      // drop a little further from there, leaving a clear, noticeable
      // gap above the gachapon machine rather than reaching down toward
      // it.
      var LAMP_TARGET_LEN_PX = 55;

      var cordLen = 0, cordVel = 0;
      var swingTheta = 0, swingVel = 0;
      var lampRafId = null;
      var lampLastTime = null;

      // Fires exactly once, the instant the cord first reaches full
      // length — everything before that point is a perfectly straight
      // drop with no sway forced onto it at all. SWING_KICK_DIR is
      // randomized per page load so the bulb doesn't swing the exact
      // same direction first every single time.
      var lampBounced = false;
      var SWING_KICK_DIR = Math.random() < 0.5 ? -1 : 1;

      // Underdamped spring (overshoots then settles) for the drop —
      // the bounce asked for. Sway is a SEPARATE, independently damped
      // spring with no ongoing coupling to the drop at all — instead of
      // being driven by the drop's own acceleration for the whole fall
      // (which used to spike hardest right at frame one, reading as a
      // jumpy sideways kick before the bulb had even started moving),
      // it gets exactly one velocity impulse at the moment of that
      // first bounce (see lampStep below), sized off how fast the cord
      // was falling at that instant, and just swings freely on its own
      // momentum from there, damping out naturally.
      var LEN_K = 95, LEN_C = 9.5;
      var SWING_K = 9, SWING_C = 1.5, SWING_IMPULSE = 0.0055;

      function lampStep(dt) {
        var lenAccel = (LAMP_TARGET_LEN_PX - cordLen) * LEN_K - cordVel * LEN_C;
        cordVel += lenAccel * dt;
        cordLen = Math.max(0, cordLen + cordVel * dt);

        if (!lampBounced && cordLen >= LAMP_TARGET_LEN_PX) {
          lampBounced = true;
          swingVel += cordVel * SWING_IMPULSE * SWING_KICK_DIR;
        }

        var swingAccel = -swingTheta * SWING_K - swingVel * SWING_C;
        swingVel += swingAccel * dt;
        swingTheta += swingVel * dt;
      }

      // Beam width scales with how far the drop has progressed
      // (0 at cordLen=0, so nothing is revealed until the bulb
      // actually starts descending) and stretches asymmetrically
      // toward whichever side the pendulum is currently swinging —
      // narrower at rest, reaching toward the screen edges mid-swing.
      function lampRender() {
        lampCord.style.height = cordLen + 'px';
        lampPivot.style.transform = 'translateX(-50%) rotate(' + (swingTheta * 180 / Math.PI).toFixed(3) + 'deg)';

        var bulbRect = lampBulb.getBoundingClientRect();
        var bulbX = bulbRect.left + bulbRect.width / 2;
        // The glow/glass sits in the BOTTOM half of the bulb graphic's
        // own box now that it's drawn base-up (see the liquid
        // template's own comment on the flipped viewBox) — 0.49 here
        // approximates the glow circle's own center within that box
        // (the light-emitting point the beam should radiate from),
        // where it used to be nearer the top before the flip.
        var bulbY = bulbRect.top + bulbRect.height * 0.49;
        // The pivot is fixed to the viewport now, but .os-gashapon__ground
        // still lives in the normal scrolling page flow — so as the
        // page scrolls, the floor can end up above the (fixed) bulb.
        // Clamping keeps the triangle's base from inverting above its
        // own apex in that case.
        var floorY = Math.max(groundEl.getBoundingClientRect().top, bulbY + 10);
        var vw = window.innerWidth, vh = window.innerHeight;

        maskBg.setAttribute('width', vw);
        maskBg.setAttribute('height', vh);

        var progress = Math.min(1, cordLen / LAMP_TARGET_LEN_PX);
        var floorAimX = bulbX + Math.tan(swingTheta) * (floorY - bulbY);
        var baseHalf = vw * 0.09 * progress;
        var stretch = swingTheta * vw * 0.55 * progress;
        var leftX = Math.max(0, Math.min(vw, floorAimX - baseHalf + Math.min(0, stretch)));
        var rightX = Math.max(0, Math.min(vw, floorAimX + baseHalf + Math.max(0, stretch)));

        maskBeam.setAttribute('points', bulbX + ',' + bulbY + ' ' + leftX + ',' + floorY + ' ' + rightX + ',' + floorY);
      }

      function lampFrame(now) {
        if (lampLastTime == null) lampLastTime = now;
        var dt = Math.min(0.05, (now - lampLastTime) / 1000);
        lampLastTime = now;

        lampStep(dt);
        lampRender();

        var settled = Math.abs(cordVel) < 0.02 && Math.abs(cordLen - LAMP_TARGET_LEN_PX) < 0.05 &&
          Math.abs(swingVel) < 0.001 && Math.abs(swingTheta) < 0.0015;
        if (settled) {
          cordLen = LAMP_TARGET_LEN_PX;
          swingTheta = 0;
          swingVel = 0;
          lampRender();
          lampRafId = null;
          return;
        }
        lampRafId = window.requestAnimationFrame(lampFrame);
      }

      function startLampPhysics() {
        // Was hidden (opacity: 0) since first paint — see
        // .os-gashapon__lamp-pivot's own CSS — so it only becomes
        // visible at the exact moment it starts actually doing
        // something, rather than sitting there fully visible (just not
        // yet dropped) from the very start of the page load.
        lampPivot.classList.add('is-visible');
        if (reducedMotion) {
          cordLen = LAMP_TARGET_LEN_PX;
          lampRender();
          return;
        }
        if (lampRafId != null) return;
        lampLastTime = null;
        lampRafId = window.requestAnimationFrame(lampFrame);
      }

      window.addEventListener('resize', function () {
        if (lampRafId == null) lampRender();
      });

      // Waits for the page's own load-in reveal to finish settling
      // (.os-gashapon__stage's own animation: 0.3s delay + 1.1s
      // duration, see component-os-gashapon.css) before dimming, so the
      // room doesn't go dark mid-way through the machines still rising
      // into place. The bulb itself then waits for the FULL dim fade
      // to finish too (1.4s, matching .os-gashapon__dim-overlay's own
      // transition: opacity duration) before it starts dropping, so it
      // reads as the very last thing to appear — page settles, room
      // goes dark, then the bulb drops into an already-dim room, not
      // partway through the dim still lightening as it falls.
      function beginBasementLighting() {
        window.setTimeout(function () {
          dimOverlay.classList.add('is-visible');
          window.setTimeout(startLampPhysics, reducedMotion ? 0 : 1400);
        }, reducedMotion ? 0 : 1400);
      }

      if (document.readyState === 'complete') {
        beginBasementLighting();
      } else {
        window.addEventListener('load', beginBasementLighting);
      }
    }

    function updateSoundLabel() {
      soundLabel.textContent = soundEnabled ? 'sound: on' : 'sound: off';
      soundToggle.setAttribute('aria-pressed', String(soundEnabled));
    }
    updateSoundLabel();

    soundToggle.addEventListener('click', function () {
      soundEnabled = !soundEnabled;
      try { localStorage.setItem('gashapon_sound', soundEnabled ? 'on' : 'off'); } catch (e) {}
      updateSoundLabel();
    });

    function getAudioCtx() {
      audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
      return audioCtx;
    }

    // A short burst of filtered-noise clicks (the individual "teeth"
    // of a ratchet catching) followed by one low thunk -- built from
    // noise, not oscillator tones, since that's what actually reads as
    // mechanical/textured rather than synthy. The only sound left in
    // this whole page: every other cue (tick/clunk, used for lever
    // landing, capsule pop, ticket flip, etc.) was removed on request
    // rather than kept as separate UI beeps alongside this. Click
    // count/spacing/pitch are all jittered per call so repeated cranks
    // don't sound like the same sample looping.
    function noiseClick(freq, duration, gainPeak) {
      if (!soundEnabled) return;
      try {
        var ctx = getAudioCtx();
        var bufferSize = Math.max(1, Math.floor(ctx.sampleRate * duration));
        var buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
        var data = buffer.getChannelData(0);
        for (var i = 0; i < bufferSize; i++) {
          // Linear decay envelope baked into the noise itself (on top
          // of the gain ramp below) gives each click a sharper, more
          // percussive leading edge than a gain ramp alone would.
          data[i] = (Math.random() * 2 - 1) * (1 - i / bufferSize);
        }
        var noise = ctx.createBufferSource();
        noise.buffer = buffer;

        var bandpass = ctx.createBiquadFilter();
        bandpass.type = 'bandpass';
        bandpass.frequency.value = freq;
        bandpass.Q.value = 5;

        var gain = ctx.createGain();
        gain.gain.setValueAtTime(gainPeak, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + duration);

        noise.connect(bandpass);
        bandpass.connect(gain);
        gain.connect(ctx.destination);
        noise.start();
        noise.stop(ctx.currentTime + duration);
      } catch (e) {}
    }

    function crankRatchet() {
      if (!soundEnabled) return;
      var clicks = 4 + Math.floor(Math.random() * 3);
      var t = 0;
      for (var i = 0; i < clicks; i++) {
        (function (delay) {
          window.setTimeout(function () {
            noiseClick(1700 + Math.random() * 900, 0.045, 0.26);
          }, delay);
        })(t);
        t += 50 + Math.random() * 35;
      }
      // A low mechanical thunk right after the last click, like the
      // gear finally catching.
      window.setTimeout(function () {
        try {
          var ctx = getAudioCtx();
          var osc = ctx.createOscillator();
          var gain = ctx.createGain();
          osc.type = 'triangle';
          osc.frequency.value = 85 + Math.random() * 15;
          gain.gain.setValueAtTime(0.16, ctx.currentTime);
          gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.18);
          osc.connect(gain);
          gain.connect(ctx.destination);
          osc.start();
          osc.stop(ctx.currentTime + 0.18);
        } catch (e) {}
      }, t);
    }

    // ---------- dome physics ----------
    // Small real-time rigid-body sim for the balls in the dome: gravity,
    // circle-circle collision with impulse-based restitution + Coulomb
    // friction, angular velocity generated by tangential slip at contact,
    // and a fixed number of substeps per rendered frame so fast-moving
    // balls can't tunnel through the dome wall or each other in one tick.
    // Churning injects shake impulses into the running sim; dispensing
    // gives the bottom of the pile an upward kick and opens a trapdoor
    // in the dome's floor, then waits for a ball to actually fall
    // through it before handing its color off to the chute animation.
    // DOME_R grew from 78 to 84 alongside the SVG's own dome circle
    // (see the section markup) to comfortably fit 15 balls instead of
    // 9 — this has to match what's actually drawn exactly, or balls
    // will visibly rest inside/outside the drawn wall instead of
    // against it.
    var DOME_CX = 120, DOME_CY = 110, DOME_R = 84;
    var GRAVITY = 480;
    var RESTITUTION = 0.6;
    var FRICTION = 0.25;
    var AIR_DAMPING = 0.02;
    var SUBSTEPS = 6;
    var TRAPDOOR_ANGLE = Math.PI / 2; // straight down from dome center
    var TRAPDOOR_HALF_WIDTH = 0.5; // radians, ~28.6° either side

    var ballEls = Array.prototype.slice.call(root.querySelectorAll('[data-gashapon-ball]'));
    // 6 more radii/spawns appended for the added balls (9 -> 15), same
    // ~10-14 range and same "spread out, let collision resolve the
    // rest" spirit as the original 9 — spawn points sit well inside
    // the new DOME_R=84 (max ~46px from center, leaving well over 2x
    // the largest ball's own radius of clearance against the wall),
    // so nothing starts clipped through it even before the sim runs.
    var ballRadii = [13, 11, 12, 14, 12, 13, 11, 10, 11, 12, 13, 11, 14, 12, 13];
    var ballSpawns = [
      [95, 88], [133, 82], [157, 104], [150, 134], [119, 146],
      [88, 138], [74, 108], [110, 108], [131, 118],
      [90, 85], [150, 85], [165, 105], [135, 145], [105, 145], [75, 105]
    ];

    var balls = ballEls.map(function (el, i) {
      var radius = ballRadii[i] || 12;
      return {
        el: el,
        x: ballSpawns[i][0],
        y: ballSpawns[i][1],
        vx: (Math.random() - 0.5) * 30,
        vy: 0,
        angle: 0,
        omega: (Math.random() - 0.5) * 3,
        radius: radius,
        mass: radius * radius,
        color: capsuleColors[i % capsuleColors.length]
      };
    });

    var trapdoorOpen = false;
    var pendingEject = null;
    var physicsRafId = null;
    var physicsLastTime = null;

    function ballInertia(b) {
      return 0.5 * b.mass * b.radius * b.radius;
    }

    function resolveBallBall(a, b) {
      var dx = b.x - a.x, dy = b.y - a.y;
      var dist = Math.sqrt(dx * dx + dy * dy);
      var minDist = a.radius + b.radius;
      if (dist === 0 || dist >= minDist) return;

      var nx = dx / dist, ny = dy / dist;
      var overlap = minDist - dist;
      var invMassA = 1 / a.mass, invMassB = 1 / b.mass;
      var totalInvMass = invMassA + invMassB;

      a.x -= nx * overlap * (invMassA / totalInvMass);
      a.y -= ny * overlap * (invMassA / totalInvMass);
      b.x += nx * overlap * (invMassB / totalInvMass);
      b.y += ny * overlap * (invMassB / totalInvMass);

      var rvx = b.vx - a.vx, rvy = b.vy - a.vy;
      var velAlongNormal = rvx * nx + rvy * ny;
      if (velAlongNormal > 0) return; // separating already

      var jn = -(1 + RESTITUTION) * velAlongNormal / totalInvMass;
      a.vx -= jn * nx * invMassA; a.vy -= jn * ny * invMassA;
      b.vx += jn * nx * invMassB; b.vy += jn * ny * invMassB;

      // friction + spin: tangential slip at the contact point includes
      // each ball's own surface speed from its angular velocity
      var tx = -ny, ty = nx;
      var surfaceTerm = a.omega * a.radius + b.omega * b.radius;
      var rvx2 = b.vx - a.vx, rvy2 = b.vy - a.vy;
      var vt = (rvx2 * tx + rvy2 * ty) - surfaceTerm;

      var jt = -vt / totalInvMass;
      var maxFriction = FRICTION * Math.abs(jn);
      jt = Math.max(-maxFriction, Math.min(maxFriction, jt));

      a.vx -= jt * tx * invMassA; a.vy -= jt * ty * invMassA;
      b.vx += jt * tx * invMassB; b.vy += jt * ty * invMassB;

      var invInertiaA = 1 / ballInertia(a), invInertiaB = 1 / ballInertia(b);
      a.omega -= jt * a.radius * invInertiaA;
      b.omega -= jt * b.radius * invInertiaB;
    }

    function resolveBallWall(b) {
      var dx = b.x - DOME_CX, dy = b.y - DOME_CY;
      var dist = Math.sqrt(dx * dx + dy * dy);
      var maxDist = DOME_R - b.radius;
      if (dist <= maxDist) return false;

      var angle = Math.atan2(dy, dx);
      var diff = Math.atan2(Math.sin(angle - TRAPDOOR_ANGLE), Math.cos(angle - TRAPDOOR_ANGLE));

      if (trapdoorOpen && Math.abs(diff) < TRAPDOOR_HALF_WIDTH) {
        return true; // fell through the open trapdoor
      }

      var nx = dx / (dist || 1), ny = dy / (dist || 1);
      var overlap = dist - maxDist;
      b.x -= nx * overlap;
      b.y -= ny * overlap;

      var vn = b.vx * nx + b.vy * ny;
      if (vn > 0) {
        b.vx -= (1 + RESTITUTION) * vn * nx;
        b.vy -= (1 + RESTITUTION) * vn * ny;

        var tx = -ny, ty = nx;
        var vt = (b.vx * tx + b.vy * ty) + b.omega * b.radius;
        var jn = (1 + RESTITUTION) * Math.abs(vn) * b.mass;
        var jt = -vt * b.mass;
        var maxFriction = FRICTION * jn;
        jt = Math.max(-maxFriction, Math.min(maxFriction, jt));

        var invMass = 1 / b.mass, invInertia = 1 / ballInertia(b);
        b.vx += jt * tx * invMass;
        b.vy += jt * ty * invMass;
        b.omega += jt * b.radius * invInertia;
      }

      return false;
    }

    function physicsSubstep(dt) {
      balls.forEach(function (b) {
        b.vy += GRAVITY * dt;
        b.x += b.vx * dt;
        b.y += b.vy * dt;
        b.angle += b.omega * dt;

        var damp = 1 - AIR_DAMPING;
        b.vx *= damp; b.vy *= damp; b.omega *= damp;
      });

      for (var i = 0; i < balls.length; i++) {
        for (var j = i + 1; j < balls.length; j++) {
          resolveBallBall(balls[i], balls[j]);
        }
      }

      for (var k = 0; k < balls.length; k++) {
        if (resolveBallWall(balls[k])) {
          var ejected = balls[k];
          balls.splice(k, 1);
          ejected.el.style.visibility = 'hidden';

          if (pendingEject) {
            var resolveFn = pendingEject.resolve;
            pendingEject = null;
            trapdoorOpen = false;
            resolveFn(ejected.color);
          }
          break;
        }
      }
    }

    function renderBalls() {
      balls.forEach(function (b) {
        var scale = b.radius / 26;
        b.el.style.transform =
          'translate(' + b.x.toFixed(2) + 'px, ' + b.y.toFixed(2) + 'px) rotate(' +
          (b.angle * 180 / Math.PI).toFixed(1) + 'deg) scale(' + scale.toFixed(3) + ')';
      });
    }

    function physicsFrame(now) {
      if (physicsLastTime == null) physicsLastTime = now;
      var frameDt = Math.min((now - physicsLastTime) / 1000, 1 / 15);
      physicsLastTime = now;

      var subDt = frameDt / SUBSTEPS;
      for (var s = 0; s < SUBSTEPS; s++) {
        physicsSubstep(subDt);
      }

      renderBalls();
      physicsRafId = window.requestAnimationFrame(physicsFrame);
    }

    function startPhysics() {
      if (physicsRafId != null || reducedMotion) return;
      physicsLastTime = null;
      physicsRafId = window.requestAnimationFrame(physicsFrame);
    }

    function churnShake() {
      var count = 2 + Math.floor(Math.random() * 2);
      for (var i = 0; i < count; i++) {
        var b = balls[Math.floor(Math.random() * balls.length)];
        if (!b) continue;
        b.vx += (Math.random() - 0.5) * 260;
        b.vy -= Math.random() * 220;
        b.omega += (Math.random() - 0.5) * 12;
      }
    }

    function dispenseAndEject() {
      if (reducedMotion) {
        var fallback = balls.shift();
        if (fallback) fallback.el.style.visibility = 'hidden';
        return Promise.resolve(fallback ? fallback.color : capsuleColors[0]);
      }

      // Loosen the pile with an upward burst, then open the trapdoor and
      // let gravity sort out which ball falls through first.
      balls.forEach(function (b) {
        if (b.y > DOME_CY) {
          b.vy -= 160 + Math.random() * 90;
          b.vx += (Math.random() - 0.5) * 60;
        }
      });

      return new Promise(function (resolve) {
        window.setTimeout(function () {
          trapdoorOpen = true;
          var settled = false;

          function finish(color) {
            if (settled) return;
            settled = true;
            resolve(color || capsuleColors[0]);
          }

          pendingEject = { resolve: finish };

          window.setTimeout(function () {
            if (settled) return;
            trapdoorOpen = false;
            pendingEject = null;

            // Nothing fell through in time — force-eject whichever ball
            // is nearest the trapdoor so the sequence never hangs.
            var nearest = null, nearestDist = Infinity;
            balls.forEach(function (b) {
              var dx = b.x - DOME_CX, dy = b.y - DOME_CY;
              var d = Math.sqrt(dx * dx + dy * dy) - (DOME_R - b.radius);
              if (d < nearestDist) { nearestDist = d; nearest = b; }
            });
            if (nearest) {
              balls.splice(balls.indexOf(nearest), 1);
              nearest.el.style.visibility = 'hidden';
              finish(nearest.color);
            } else {
              finish(capsuleColors[0]);
            }
          }, 1600);
        }, 150);
      });
    }

    renderBalls();
    startPhysics();

    function readState() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) { return null; }
    }

    function writeState(prize) {
      var record = { playedAt: Date.now(), prize: prize };
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(record)); } catch (e) {}
      return record;
    }

    function formatDate(ts) {
      var d = new Date(ts);
      return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
    }

    // Fills in a ticket-back's content (label/code/copy/link/note) —
    // shared between the animated ticket's back face and the plain
    // static duplicate shown under "view your prize again", so both
    // stay in sync with one source of truth.
    function populateTicketBack(container, prize) {
      var label = container.querySelector('[data-prize-label]');
      var code = container.querySelector('[data-prize-code]');
      var copy = container.querySelector('[data-prize-copy]');
      var link = container.querySelector('[data-prize-link]');

      label.textContent = prize.label;

      if (prize.kind === 'code' && prize.code) {
        code.textContent = prize.code;
        code.hidden = false;
        copy.hidden = false;
        copy.onclick = function () {
          if (navigator.clipboard) {
            navigator.clipboard.writeText(prize.code).then(function () {
              copy.textContent = 'copied';
              window.setTimeout(function () { copy.textContent = 'copy code'; }, 1600);
            });
          }
        };
      } else {
        code.hidden = true;
        copy.hidden = true;
      }

      if (prize.url) {
        link.href = prize.url;
        link.hidden = false;
        link.textContent = prize.kind === 'link' ? 'view' : 'shop now';
      } else {
        link.hidden = true;
      }
    }

    function showLocked(record) {
      var nextEligible = record.playedAt + replayDays * 24 * 60 * 60 * 1000;
      stage.hidden = true;
      lockedPanel.hidden = false;
      lockedDate.textContent = formatDate(nextEligible);

      if (record.prize) {
        viewAgainButton.hidden = false;
        viewAgainButton.addEventListener('click', function () {
          viewAgainButton.hidden = true;
          populateTicketBack(lockedTicketBack, record.prize);
          lockedTicket.hidden = false;
        }, { once: true });
      }
    }

    function pickPrize() {
      var total = prizes.reduce(function (sum, p) { return sum + (Number(p.weight) || 1); }, 0);
      var roll = Math.random() * total;
      var acc = 0;
      for (var i = 0; i < prizes.length; i++) {
        acc += Number(prizes[i].weight) || 1;
        if (roll <= acc) return prizes[i];
      }
      return prizes[prizes.length - 1];
    }

    function randomBetween(min, max) {
      return min + Math.random() * (max - min);
    }

    function animatePull() {
      root.classList.remove('is-idle');

      if (reducedMotion) {
        leverPivot.style.transform = 'rotate(165deg)';
        return Promise.resolve();
      }

      var anim = leverPivot.animate(
        [
          { transform: 'rotate(0deg)', offset: 0 },
          { transform: 'rotate(40deg)', offset: 0.55 },
          { transform: 'rotate(165deg)', offset: 1 }
        ],
        { duration: 1100, easing: 'cubic-bezier(.7,0,.84,0)', fill: 'forwards' }
      );

      return anim.finished.catch(function () {});
    }

    function animateChurn() {
      root.classList.add('is-churning');

      if (reducedMotion) {
        root.classList.remove('is-churning');
        crankRatchet();
        return Promise.resolve();
      }

      var churnDuration = 2800;
      [0, 700, 1400, 2100].forEach(function (t) {
        window.setTimeout(function () {
          crankRatchet();
          churnShake();
        }, t);
      });

      return new Promise(function (resolve) {
        window.setTimeout(function () {
          root.classList.remove('is-churning');
          resolve();
        }, churnDuration);
      });
    }

    function animateDispense(capColor) {
      capsule.style.setProperty('--gasha-cap-color', capColor || capsuleColors[0]);
      capsule.hidden = false;
      capsule.style.left = '50%';
      capsule.style.top = '83%';

      if (reducedMotion) {
        capsule.style.transform = 'translate(-50%, -50%) scale(1)';
        return Promise.resolve();
      }

      var anim = capsule.animate(
        [
          { transform: 'translate(-50%, -50%) scale(0)', offset: 0 },
          { transform: 'translate(-50%, -50%) scale(1.08)', offset: 0.7 },
          { transform: 'translate(-50%, -50%) scale(1)', offset: 1 }
        ],
        { duration: 320, easing: 'ease-out', fill: 'forwards' }
      );

      // fill:'forwards' keeps this WAAPI animation's transform pinned on
      // the element — with higher priority than plain inline styles —
      // even after it finishes. Left uncancelled, it silently blocks
      // every rotate() the physics loop below tries to apply via
      // style.transform, so the capsule translates but never visibly
      // spins. Cancelling hands control of transform back to inline
      // style, which the roll's first frame overwrites immediately.
      return anim.finished.catch(function () {}).then(function () {
        anim.cancel();
      });
    }

    // ---------- floor physics (the dispensed capsule) ----------
    // The capsule drops from the flap onto a flat floor plane leveled
    // with the machine's base (the .os-gashapon__ground line) and rolls
    // to a stop under its own rigid-body dynamics: gravity, a bounce on
    // first contact, then Coulomb stick/slip friction that smoothly
    // converts linear velocity into spin (static friction is stronger
    // than kinetic, so once slip is small enough the capsule "sticks"
    // into pure rolling in a single substep instead of sliding forever),
    // plus rolling resistance + viscous damping so it actually comes to
    // rest in a couple of seconds rather than rolling indefinitely. Low-
    // restitution invisible walls just inside the frame edges keep a
    // fast roll from ever leaving the canvas.
    var FLOOR_GRAVITY = 480;
    var FLOOR_STATIC_FRICTION = 0.4;
    var FLOOR_DYNAMIC_FRICTION = 0.3;
    var ROLLING_FRICTION = 0.2;
    var ROLLING_FRICTION_REF_RATE = 6; // reference scale the 0.2 coefficient multiplies into a per-second angular damping rate
    // Bouncier than a real hollow-plastic capsule would be — retains
    // more of its vertical speed per bounce (was 0.35), so it hops
    // several more times, taking noticeably longer to settle instead of
    // thudding down after one or two bounces.
    var FLOOR_BOUNCE_RESTITUTION = 0.62;
    // Each real bounce (not just rolling contact) also nudges it
    // further along in whatever direction it launched — a real bounce
    // carries some of its horizontal momentum through the hop instead
    // of only ever losing speed to friction, so it keeps traveling
    // forward, hop by hop, rather than bouncing near in place once
    // friction has eaten the initial slip.
    var FLOOR_BOUNCE_FORWARD_BOOST = 42;
    var EDGE_RESTITUTION = 0.2;
    var EDGE_PADDING_RATIO = 0.06;
    var ROLL_SUBSTEPS = 6;

    function renderCapsule(x, y, angleDeg) {
      capsule.style.left = x.toFixed(2) + 'px';
      capsule.style.top = y.toFixed(2) + 'px';
      capsule.style.transform = 'translate(-50%, -50%) rotate(' + angleDeg.toFixed(1) + 'deg)';
    }

    function animateRoll() {
      if (reducedMotion) {
        var finalXPercent = randomBetween(18, 82);
        capsule.style.left = finalXPercent + '%';
        capsule.style.top = '78%';
        capsule.style.transform = 'translate(-50%, -50%)';
        return Promise.resolve();
      }

      var stageRect = stage.getBoundingClientRect();
      var groundRect = groundEl.getBoundingClientRect();
      var canvasWidth = stageRect.width;
      // The line itself measures exactly at the pegs' bottom edge, but
      // the capsule's own stroke/anti-aliasing reads as sitting a touch
      // high against it — nudge the resting plane down slightly so it
      // visually meets the line instead of hovering just above it.
      var floorY = groundRect.top - stageRect.top + 8;
      var padding = canvasWidth * EDGE_PADDING_RATIO;
      // Read the capsule's actual rendered size instead of duplicating
      // its CSS width as a formula here — the stage is full-bleed to
      // the screen now, so canvasWidth no longer has a fixed relationship
      // to the capsule's own (fixed-size) CSS box.
      var radius = parseFloat(window.getComputedStyle(capsule).width) / 2;

      var mass = radius * radius; // area-proportional, same convention as the dome balls
      var invMass = 1 / mass;
      // Hollow thin-shelled sphere, not a solid disc — a real gashapon
      // capsule is hollow plastic. I = (2/3) * m * r^2, versus (1/2) for
      // a solid disc: more inertia per unit mass, so the same torque
      // spins it up more gradually.
      var inertia = (2 / 3) * mass * radius * radius;
      var invInertia = 1 / inertia;

      var direction = Math.random() < 0.5 ? -1 : 1;
      var launchVx = direction * randomBetween(140, 220);
      var state = {
        x: canvasWidth * 0.5,
        y: stageRect.height * 0.83,
        vx: launchVx,
        vy: 0,
        theta: 0, // angular position, radians
        // Starts already spinning to match its launch speed, rather than
        // 0 — physically a free-falling capsule wouldn't spin until it
        // hit something, but visually that read as a delay between the
        // capsule moving and it starting to roll. This way rotation and
        // translation begin on the same frame.
        omega: launchVx / radius
      };

      var grounded = false;
      var rafId = null;
      var lastTime = null;

      // Once the roll's own physics first comes to rest, it doesn't
      // settle for good — it keeps wobbling side to side, permanently,
      // as the capsule's idle "waiting to be tapped" animation (this
      // replaces the old separate WAAPI idle-hop entirely; the two
      // can't run at once, they'd fight over the same element). Not a
      // canned animation: it's the exact same substep()
      // gravity/restitution/friction loop above, just periodically
      // re-energized with a small random left-or-right kick (only ever
      // applied while grounded, like a real nudge) whose strength
      // decays linearly to zero across a 4-second window — then the
      // window resets and it kicks off again, looping for as long as
      // the capsule sits unopened. Rotation is frozen for the whole of
      // this phase (see the phase guards in substep() below) — only
      // the roll itself spins the capsule; once it's down to bouncing
      // in place, it stops turning.
      var phase = 'rolling';
      var wobbleStartTime = null;
      var wobbleDurationMs = null;
      var nextKickTime = null;
      var kickCount = 0;
      var firstKickDir = null;
      var POST_ROLL_WOBBLE_MS = 4000;
      var POST_ROLL_KICK_INTERVAL_MIN_MS = 280;
      var POST_ROLL_KICK_INTERVAL_MAX_MS = 420;
      var POST_ROLL_KICK_VY_MIN = 120;
      var POST_ROLL_KICK_VY_MAX = 220;
      var POST_ROLL_KICK_VX_MIN = 40;
      var POST_ROLL_KICK_VX_MAX = 110;

      return new Promise(function (resolve) {
        function substep(dt) {
          state.vy += FLOOR_GRAVITY * dt;
          state.x += state.vx * dt;
          state.y += state.vy * dt;
          // Only the roll itself spins the capsule — frozen once it's
          // down to the permanent idle wobble (phase 'wobbling'), so it
          // bounces in place without turning.
          if (phase !== 'wobbling') {
            state.theta += state.omega * dt;
          }

          if (state.y + radius >= floorY) {
            state.y = floorY - radius;

            if (state.vy > 0) {
              if (state.vy < 40) {
                state.vy = 0;
                grounded = true;
              } else {
                state.vy = -state.vy * FLOOR_BOUNCE_RESTITUTION;
                // Only the initial roll gets pushed further along in
                // its launch direction — the idle wobble's kicks set
                // their own vx directly each time, so adding this on
                // top would double up with them.
                if (phase !== 'wobbling') {
                  state.vx += direction * FLOOR_BOUNCE_FORWARD_BOOST;
                }
                grounded = false;
              }
            } else {
              grounded = true;
            }

            if (phase === 'wobbling') {
              // Same idea as rolling friction below (bleeds speed off
              // on every ground touch) but with no torque/spin term at
              // all — just a flat deceleration toward zero, since this
              // phase never rotates.
              var wobbleFriction = FLOOR_DYNAMIC_FRICTION * FLOOR_GRAVITY;
              if (state.vx > 0) {
                state.vx = Math.max(0, state.vx - wobbleFriction * dt);
              } else if (state.vx < 0) {
                state.vx = Math.min(0, state.vx + wobbleFriction * dt);
              }
            } else {
              // Ground contact, on every touch — a bounce included, not
              // just once fully at rest, so it visibly starts skidding
              // and spinning the instant it first hits the floor.
              //
              // Tangential friction is a real force, F = mu * N, not a
              // capped impulse. Comparing the FORCE needed to fully
              // cancel slip this instant against the static budget
              // (mu_s * N) decides the regime:
              //   - under budget: static friction supplies exactly what's
              //     needed — it sticks, v and omega*radius match exactly.
              //   - over budget: still skidding, so kinetic friction
              //     (mu_k * N) applies instead — a torque = radius * F
              //     spins the capsule up while the same force decelerates
              //     v, so v drops and omega climbs together until they
              //     meet at v = omega * radius.
              var slip = state.vx - state.omega * radius;
              var normalForce = mass * FLOOR_GRAVITY;
              var forceNeeded = (-slip / (invMass + radius * radius * invInertia)) / dt;
              var staticMax = FLOOR_STATIC_FRICTION * normalForce;

              if (Math.abs(forceNeeded) <= staticMax) {
                // Sticks: pure rolling. Apply the exact impulse that
                // zeroes slip, then bleed the spin off with a small
                // rolling-friction angular damping — resyncing
                // v = omega * radius after keeps linear speed dropping
                // in lockstep with the spin, down to a dead stop.
                var jStick = forceNeeded * dt;
                state.vx += jStick * invMass;
                state.omega += -jStick * radius * invInertia;

                state.omega *= (1 - ROLLING_FRICTION * ROLLING_FRICTION_REF_RATE * dt);
                state.vx = state.omega * radius;
              } else {
                // Skidding: kinetic friction as a genuine force + torque.
                var fFriction = FLOOR_DYNAMIC_FRICTION * normalForce;
                var torque = radius * fFriction;

                state.vx -= Math.sign(slip) * (fFriction / mass) * dt;
                state.omega += Math.sign(slip) * (torque * invInertia) * dt;
              }
            }
          }

          if (state.x - radius < padding) {
            state.x = padding + radius;
            state.vx = -state.vx * EDGE_RESTITUTION;
            if (phase !== 'wobbling') state.omega = state.vx / radius;
          } else if (state.x + radius > canvasWidth - padding) {
            state.x = canvasWidth - padding - radius;
            state.vx = -state.vx * EDGE_RESTITUTION;
            if (phase !== 'wobbling') state.omega = state.vx / radius;
          }
        }

        // Fires once, the instant the roll's own physics first comes to
        // rest — freezes rotation, hands the promise forward so
        // armOpenHandler can arm the tap listener immediately, and
        // starts the first 4-second wobble window. frame() below keeps
        // running after this (it never stops itself again), looping
        // fresh wobble windows until armOpenHandler cancels
        // capsuleWobbleRafId on tap.
        function beginIdleWobble(now) {
          state.vx = 0; state.vy = 0; state.omega = 0;
          renderCapsule(state.x, state.y, state.theta * 180 / Math.PI);
          phase = 'wobbling';
          wobbleStartTime = now;
          wobbleDurationMs = POST_ROLL_WOBBLE_MS;
          nextKickTime = now;
          resolve();
        }

        function frame(now) {
          if (lastTime == null) lastTime = now;
          var frameDt = Math.min((now - lastTime) / 1000, 1 / 15);
          lastTime = now;

          var subDt = frameDt / ROLL_SUBSTEPS;
          for (var s = 0; s < ROLL_SUBSTEPS; s++) {
            substep(subDt);
          }

          renderCapsule(state.x, state.y, state.theta * 180 / Math.PI);

          var speed = Math.abs(state.vx) + Math.abs(state.vy) + Math.abs(state.omega) * radius;

          if (phase === 'rolling') {
            if (grounded && speed < 4) {
              beginIdleWobble(now);
            }
          } else {
            var wobbleElapsed = now - wobbleStartTime;
            if (wobbleElapsed < wobbleDurationMs) {
              if (now >= nextKickTime && grounded) {
                var damp = 1 - wobbleElapsed / wobbleDurationMs;
                var kickDir;
                if (kickCount === 0) {
                  kickDir = Math.random() < 0.5 ? -1 : 1;
                  firstKickDir = kickDir;
                } else if (kickCount === 1) {
                  // Always the opposite of the first bounce, like a real
                  // rebound off whatever it just hit — every kick after
                  // this one goes back to random.
                  kickDir = -firstKickDir;
                } else {
                  kickDir = Math.random() < 0.5 ? -1 : 1;
                }
                kickCount++;
                state.vy = -randomBetween(POST_ROLL_KICK_VY_MIN, POST_ROLL_KICK_VY_MAX) * damp;
                state.vx = kickDir * randomBetween(POST_ROLL_KICK_VX_MIN, POST_ROLL_KICK_VX_MAX) * damp;
                grounded = false;
                nextKickTime = now + randomBetween(POST_ROLL_KICK_INTERVAL_MIN_MS, POST_ROLL_KICK_INTERVAL_MAX_MS);
              }
            } else {
              // The 4-second window ran out — instead of settling for
              // good, loop: reset and let it kick off again.
              wobbleStartTime = now;
              kickCount = 0;
              firstKickDir = null;
              nextKickTime = now;
            }
          }

          rafId = window.requestAnimationFrame(frame);
          capsuleWobbleRafId = rafId;
        }

        rafId = window.requestAnimationFrame(frame);
      });
    }

    // ---------- prize ticket (pops out of the capsule, then reveals) ----------
    // Three steps, each a separate function so the sequence reads the
    // same way it plays: emerge (tiny, at the capsule, growing as it
    // floats up to a small bobbing rest position) → reveal (tap 1: fades
    // and scales in already centered on screen, fixed to the viewport,
    // as the top-most layer on the page) → flip (tap 2: rotates over on
    // its horizontal axis to show the prize on its back face).
    var GASHA_TICKET_FLOAT_UP_PX = 70;
    var GASHA_TICKET_POP_MS = 650;
    var GASHA_TICKET_FLIP_MS = 620;

    function emergeTicket(prize) {
      populateTicketBack(ticketBack, prize);
      ticket.hidden = false;
      ticket.classList.add('is-mini');

      if (reducedMotion) {
        ticketWiggle.classList.add('is-idle');
        attachRevealHandler(prize);
        return;
      }

      var capsuleLeftPx = parseFloat(capsule.style.left) || 0;
      var capsuleTopPx = parseFloat(capsule.style.top) || 0;
      var miniTopPx = capsuleTopPx - GASHA_TICKET_FLOAT_UP_PX;

      ticket.style.left = capsuleLeftPx.toFixed(2) + 'px';
      ticket.style.top = miniTopPx.toFixed(2) + 'px';

      var anim = ticket.animate(
        [
          { transform: 'translate(-50%, calc(-50% + ' + GASHA_TICKET_FLOAT_UP_PX + 'px)) scale(0.05)', offset: 0 },
          { transform: 'translate(-50%, calc(-50% + ' + (GASHA_TICKET_FLOAT_UP_PX * 0.15).toFixed(2) + 'px)) scale(1.08)', offset: 0.75 },
          { transform: 'translate(-50%, -50%) scale(1)', offset: 1 }
        ],
        { duration: GASHA_TICKET_POP_MS, easing: 'ease-out', fill: 'forwards' }
      );

      anim.finished.catch(function () {}).then(function () {
        anim.cancel();
        ticketWiggle.classList.add('is-idle');
        attachRevealHandler(prize);
      });
    }

    function attachRevealHandler(prize) {
      ticket.setAttribute('tabindex', '0');
      ticket.setAttribute('role', 'button');
      ticket.setAttribute('aria-label', 'Tap to reveal your prize');
      status.textContent = 'a ticket floated out of the capsule. tap it.';

      function onKey(evt) {
        if (evt.key === 'Enter' || evt.key === ' ') {
          evt.preventDefault();
          go();
        }
      }

      function go() {
        ticket.removeEventListener('click', go);
        ticket.removeEventListener('keydown', onKey);
        revealTicket(prize);
      }

      ticket.addEventListener('click', go);
      ticket.addEventListener('keydown', onKey);
    }

    // Eases the wiggle's current tilt back to neutral first, instead of
    // cutting the CSS animation and letting it jump straight to 0deg —
    // that instant snap was happening at the exact moment the enlarge
    // animation started, reading as part of the same motion (like an
    // overshoot) even though it was really a separate, unrelated jump.
    function settleWiggle(done) {
      if (reducedMotion) {
        ticketWiggle.classList.remove('is-idle');
        done();
        return;
      }

      var current = getComputedStyle(ticketWiggle).transform;
      if (current === 'none') {
        ticketWiggle.classList.remove('is-idle');
        done();
        return;
      }

      var anim = ticketWiggle.animate(
        [{ transform: current }, { transform: 'none' }],
        { duration: 220, easing: 'ease-out', fill: 'forwards' }
      );
      anim.finished.catch(function () {}).then(function () {
        anim.cancel();
        ticketWiggle.classList.remove('is-idle');
        done();
      });
    }

    function revealTicket(prize) {
      if (reducedMotion) {
        ticketWiggle.classList.remove('is-idle');
        ticket.style.left = '';
        ticket.style.top = '';
        ticket.classList.remove('is-mini');
        ticket.classList.add('is-open');
        ticketWiggle.classList.add('is-idle');
        attachFlipHandler(prize);
        return;
      }

      settleWiggle(function () {
        continueReveal(prize);
      });
    }

    // The ticket's final resting spot is fixed to the viewport, dead
    // center (see .os-gashapon__ticket.is-open's own CSS) — a totally
    // different coordinate system than the mini state's own in-page,
    // capsule-relative position, so the old FLIP-technique "fly from
    // the mini spot to the final spot" animation (computing a pixel
    // delta between the two) no longer has two comparable positions to
    // bridge. Simpler now: the ticket just fades/scales in already
    // sitting at its final centered spot, via .is-entering as the
    // pre-transition starting state (added together with .is-open,
    // then removed one frame later so the browser has actually
    // registered start!=end before the CSS transition on .is-open
    // itself kicks in and animates between them).
    // GASHA_TICKET_REVEAL_MS matches .is-open's own transform
    // transition duration (0.5s) in component-os-gashapon.css — a
    // plain timer here rather than listening for transitionend, since
    // .is-open transitions BOTH transform and opacity together and a
    // couple of Web Animations composite/replace quirks already bit
    // this exact reveal step once before (see the git history for the
    // FLIP-technique version this replaced); a fixed timer sidesteps
    // relying on event-timing details entirely, the same way the
    // churn/dispense sequence elsewhere in this file already does.
    var GASHA_TICKET_REVEAL_MS = 500;

    function continueReveal(prize) {
      // Clears the inline left/top emergeTicket set for the mini,
      // capsule-relative position — left over, those would outrank
      // .is-open's own CSS (position: fixed; left: 50%; top: 50%;)
      // entirely, since inline styles beat class-based rules.
      ticket.style.left = '';
      ticket.style.top = '';
      ticket.classList.remove('is-mini');
      ticket.classList.add('is-open', 'is-entering');
      // Forces layout now, with .is-entering's starting values applied
      // — without this the browser could coalesce this frame with the
      // rAF callback below removing .is-entering, and never actually
      // paint the starting state to transition from.
      void ticket.offsetWidth;

      requestAnimationFrame(function () {
        ticket.classList.remove('is-entering');
      });

      window.setTimeout(function () {
        attachFlipHandler(prize);
        // The rocking keyframes (see @keyframes gasha-ticket-idle) start
        // at rotate(3deg), not 0deg — turning it on the instant this
        // fade/scale-in finishes made the ticket snap 3deg off-axis
        // right as it landed, reading like an overshoot even though the
        // fade/scale itself never goes past its own resting values.
        // This pause is what makes the ticket genuinely sit still,
        // fully settled, before the rocking gets its own separate
        // moment to begin.
        window.setTimeout(function () {
          ticketWiggle.classList.add('is-idle');
        }, 400);
      }, GASHA_TICKET_REVEAL_MS);
    }

    function attachFlipHandler(prize) {
      ticketPrompt.hidden = false;
      status.textContent = 'tap the ticket to reveal your prize.';

      function onKey(evt) {
        if (evt.key === 'Enter' || evt.key === ' ') {
          evt.preventDefault();
          go();
        }
      }

      function go() {
        ticket.removeEventListener('click', go);
        ticket.removeEventListener('keydown', onKey);
        flipTicket(prize);
      }

      ticket.addEventListener('click', go);
      ticket.addEventListener('keydown', onKey);
    }

    function flipTicket(prize) {
      ticketPrompt.hidden = true;
      // Settled on the final "you got X" face — stop bobbing so the
      // prize text and code sit still and stay easy to read/copy.
      ticketWiggle.classList.remove('is-idle');
      ticket.removeAttribute('tabindex');
      ticket.removeAttribute('role');
      ticket.removeAttribute('aria-label');
      ticketFlip.classList.add('is-flipped');

      window.setTimeout(function () {
        status.textContent = 'you got: ' + prize.label;
        writeState(prize);
      }, reducedMotion ? 0 : GASHA_TICKET_FLIP_MS);
    }

    function armOpenHandler(prize) {
      status.textContent = 'capsule landed. tap it to open.';
      capsule.setAttribute('tabindex', '0');
      capsule.setAttribute('role', 'button');
      capsule.setAttribute('aria-label', 'Open capsule');
      capsule.classList.add('is-ready');

      function open() {
        // The idle wobble (animateRoll) has been bouncing the capsule
        // in place ever since it landed — cancel that loop the instant
        // it's tapped, or it'll keep animating the capsule's position
        // out from under the lid-open animation below.
        if (capsuleWobbleRafId) {
          window.cancelAnimationFrame(capsuleWobbleRafId);
          capsuleWobbleRafId = null;
        }
        capsule.removeEventListener('click', open);
        capsule.removeEventListener('keydown', onKey);
        capsule.classList.remove('is-ready');
        capsule.classList.add('is-open');
        capsule.removeAttribute('tabindex');
        capsule.removeAttribute('role');

        if (!reducedMotion) {
          capsuleTop.animate(
            [{ transform: 'translateY(0)' }, { transform: 'translateY(-9px)' }],
            { duration: 420, easing: 'ease-out', fill: 'forwards' }
          );
          capsuleBottom.animate(
            [{ transform: 'translateY(0)' }, { transform: 'translateY(9px)' }],
            { duration: 420, easing: 'ease-out', fill: 'forwards' }
          );
        }

        window.setTimeout(function () {
          emergeTicket(prize);
        }, reducedMotion ? 0 : 380);
      }

      function onKey(evt) {
        if (evt.key === 'Enter' || evt.key === ' ') {
          evt.preventDefault();
          open();
        }
      }

      capsule.addEventListener('click', open);
      capsule.addEventListener('keydown', onKey);
      capsule.focus();
    }

    function play() {
      if (pending || !prizes.length) return;
      pending = true;
      root.classList.remove('is-idle');
      leverButton.disabled = true;
      leverButton.setAttribute('aria-disabled', 'true');
      status.textContent = 'pulling the lever…';

      animatePull()
        .then(animateChurn)
        .then(dispenseAndEject)
        .then(function (capColor) {
          return animateDispense(capColor);
        })
        .then(animateRoll)
        .then(function () {
          var prize = pickPrize();
          armOpenHandler(prize);
        });
    }

    leverButton.addEventListener('click', play);

    var existing = readState();
    if (existing && existing.playedAt && (Date.now() - existing.playedAt) < replayDays * 24 * 60 * 60 * 1000) {
      showLocked(existing);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["os-hero-scatter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-hero-tiles]');
    if (!roots.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    // Scroll speed stays constant no matter how many photos a column
    // holds: duration scales with the loop's total height, measured in
    // column-widths (sum of each photo's height/width from its own
    // width/height attributes, halved since the track holds the loop
    // twice). ~6s per column-width matches the original 3-photo, 30s
    // loop, so adding or removing photos never speeds the reel up.
    var MS_PER_COLUMN_WIDTH = 6000;

    function loopDurationMs(track) {
      var total = 0;
      track.querySelectorAll('img').forEach(function (img) {
        var w = parseFloat(img.getAttribute('width'));
        var h = parseFloat(img.getAttribute('height'));
        if (w > 0 && h > 0) total += h / w;
      });
      return Math.max(total / 2, 1) * MS_PER_COLUMN_WIDTH;
    }

    roots.forEach(function (root) {
      [
        { selector: '.os-hero-tiles__col--a', direction: 'normal' },
        { selector: '.os-hero-tiles__col--b', direction: 'reverse' }
      ].forEach(function (config) {
        var col = root.querySelector(config.selector);
        var track = col && col.querySelector('.os-hero-tiles__track');
        if (!track) return;

        track.animate(
          [
            { transform: 'translateY(0)' },
            { transform: 'translateY(-50%)' }
          ],
          {
            duration: loopDurationMs(track),
            iterations: Infinity,
            easing: 'linear',
            direction: config.direction
          }
        );
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["os-mood"] && !Shopify.designMode) return;
  try {
    
  /* ---------- One-at-a-time photo reveal ----------
     Not gated behind (hover: hover)/(pointer: fine) like the enlarge
     IIFE below — this is a load-time entrance, not a hover
     interaction, so it should play the same on touch devices too. Pure
     fade (CSS handles the opacity transition), each photo set visible
     at its own randomized delay within a shared window — the exact
     same overlapping-stagger math as the about page crossword's
     letter-by-letter reveal, just applied to 15 photos instead of
     hundreds of letters. */
  (function () {
    var board = document.querySelector('[data-mood-board]');
    if (!board) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var photos = Array.from(board.querySelectorAll('.os-mood__photo'));
    if (!photos.length) return;

    var ENTRANCE_MS = 1500;
    var PHOTO_FADE_MS = 400;

    function shuffle(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    }

    var shuffled = shuffle(photos);
    shuffled.forEach(function (photo, i) {
      var delay = shuffled.length > 1
        ? (i / (shuffled.length - 1)) * (ENTRANCE_MS - PHOTO_FADE_MS)
        : 0;
      setTimeout(function () { photo.style.opacity = '1'; }, delay);
    });
  })();

  (function () {
    var board = document.querySelector('[data-mood-board]');
    if (!board) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    /* Desktop-only, hover-only: below this width the board switches to
       the wrapped/stacked mobile layout (see the 989px breakpoint in
       component-os-ui.css), where there's no cursor to hover with
       anyway. */
    var DESKTOP_MIN_WIDTH = 990;

    var hoveredPhoto = null;

    function isDesktopLayout() {
      return window.innerWidth > DESKTOP_MIN_WIDTH;
    }

    board.querySelectorAll('.os-mood__photo').forEach(function (photo) {
      photo.addEventListener('mouseenter', function () {
        /* The photo no longer grows on hover, but this is still
           tracked: the edge-scroll effect below reads it to pause
           itself while the cursor is sitting still over a photo. */
        hoveredPhoto = photo;
      });

      photo.addEventListener('mouseleave', function () {
        if (hoveredPhoto === photo) hoveredPhoto = null;
      });
    });

    /* ---------- Edge-scroll: page follows the cursor's height ----------
       Top third of the viewport scrolls up, middle third holds still,
       bottom third scrolls down — a continuous velocity that eases
       toward its target every frame rather than snapping to a fixed
       speed the instant the cursor crosses a zone line, so it reads as
       one continuous "liquid" motion instead of a mechanical trigger.
       Runs alongside normal wheel/trackpad scrolling, never replacing
       it — this only ever adds its own delta on top. */
    var nav = document.querySelector('.os-nav-top');
    /* Set/read by the separate click-to-preview script below (kept out
       of this hover-gated IIFE so the preview itself can still work on
       touch — see that script's own comment). Reading the DOM's own
       hidden state directly, rather than sharing a JS variable across
       the two closures, keeps them decoupled without needing an event
       bus for one boolean. */
    var previewRoot = document.querySelector('[data-mood-preview]');
    /* Both constants are in real-world units (px/second, and a
       decay-per-second rate) rather than "per frame" — a per-frame
       model silently assumes 60fps, and running it on a display that
       actually renders faster (this was caught testing on a 166Hz
       setup) makes the scroll run visibly faster than intended, since
       more frames means more accumulated px per second. Working in
       delta-time keeps the speed honestly the same regardless of the
       display's refresh rate. */
    var SCROLL_MAX_SPEED = 165; // px/second at full ease-in — half of the original 330
    var SCROLL_EASE_RATE = 3.71; // chosen so this feels identical to the old 0.06-per-frame ramp at 60fps
    var lastClientY = null;
    var scrollVelocity = 0; // px/second
    var lastFrameTime = null;

    document.addEventListener('mousemove', function (e) {
      lastClientY = e.clientY;
    }, { passive: true });

    document.addEventListener('mouseleave', function () {
      lastClientY = null;
    });

    function edgeScrollTick(now) {
      requestAnimationFrame(edgeScrollTick);

      if (lastFrameTime === null) {
        lastFrameTime = now;
        return;
      }
      var dt = (now - lastFrameTime) / 1000;
      lastFrameTime = now;
      /* Guards against a runaway scroll jump after the tab sits
         backgrounded/throttled for a while — rAF can deliver one huge
         dt on return instead of many small ones. */
      if (dt > 0.1) dt = 0.1;

      var targetVelocity = 0;

      if (isDesktopLayout() && lastClientY !== null && !hoveredPhoto && (!previewRoot || previewRoot.hidden)) {
        var vh = window.innerHeight;
        var topZoneEnd = vh / 3;
        var bottomZoneStart = (vh * 2) / 3;
        /* The fixed header overlays the top of the screen regardless of
           scroll position — hovering it to read the nav shouldn't also
           drag the page upward out from under the cursor. */
        var navBottom = nav ? nav.getBoundingClientRect().bottom : 0;

        if (lastClientY < topZoneEnd && lastClientY >= navBottom) {
          targetVelocity = -SCROLL_MAX_SPEED;
        } else if (lastClientY >= bottomZoneStart) {
          targetVelocity = SCROLL_MAX_SPEED;
        }
      }

      var ease = 1 - Math.exp(-SCROLL_EASE_RATE * dt);
      scrollVelocity += (targetVelocity - scrollVelocity) * ease;

      if (Math.abs(scrollVelocity) > 0.5) {
        window.scrollBy(0, scrollVelocity * dt);
      }
    }

    requestAnimationFrame(edgeScrollTick);
  })();

  /* ---------- Click-to-preview ----------
     A separate IIFE from the block above, and deliberately NOT gated
     behind (hover: hover) and (pointer: fine): the hover-enlarge and
     edge-scroll effects only make sense with a hovering cursor, but a
     click/tap-triggered preview has a natural touch equivalent, so
     this works on mobile too. Only prefers-reduced-motion is checked
     here — reduced motion still gets a preview, just without the
     grow/shrink animation. */
  (function () {
    var board = document.querySelector('[data-mood-board]');
    var root = document.querySelector('[data-mood-preview]');
    var backdrop = document.querySelector('[data-mood-preview-backdrop]');
    var img = document.querySelector('[data-mood-preview-img]');
    if (!board || !root || !backdrop || !img) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var PREVIEW_MS = reducedMotion ? 0 : 450;
    var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
    /* 0.4 * 1.6 = 0.64 — the preview's bounding box grew 60%, from
       40% of the viewport to 64%. */
    var MAX_VW = 0.64;
    var MAX_VH = 0.64;

    var activePhoto = null;
    var closeTimer = null;

    function targetRectFor(photo) {
      var maxWidth = window.innerWidth * MAX_VW;
      var maxHeight = window.innerHeight * MAX_VH;
      var nw = photo.naturalWidth || maxWidth;
      var nh = photo.naturalHeight || maxHeight;
      var scale = Math.min(maxWidth / nw, maxHeight / nh);
      var width = nw * scale;
      var height = nh * scale;
      return {
        left: (window.innerWidth - width) / 2,
        top: (window.innerHeight - height) / 2,
        width: width,
        height: height
      };
    }

    function setImgRect(rect, withTransition) {
      img.style.transition = withTransition ? ('left ' + PREVIEW_MS + 'ms ' + EASING + ', top ' + PREVIEW_MS + 'ms ' + EASING + ', width ' + PREVIEW_MS + 'ms ' + EASING + ', height ' + PREVIEW_MS + 'ms ' + EASING) : 'none';
      img.style.left = rect.left + 'px';
      img.style.top = rect.top + 'px';
      img.style.width = rect.width + 'px';
      img.style.height = rect.height + 'px';
    }

    /* Same FLIP shape as the enlarge effect's applyColumnWidths: pin the
       true starting rect with transitions off, force a layout flush,
       then switch the transition on and write the real target — so the
       animation always has a genuine "from" value instead of snapping. */
    function animateTo(rect, durationMs) {
      img.style.transition = 'none';
      void img.offsetWidth;
      img.style.transition = 'left ' + durationMs + 'ms ' + EASING + ', top ' + durationMs + 'ms ' + EASING + ', width ' + durationMs + 'ms ' + EASING + ', height ' + durationMs + 'ms ' + EASING;
      img.style.left = rect.left + 'px';
      img.style.top = rect.top + 'px';
      img.style.width = rect.width + 'px';
      img.style.height = rect.height + 'px';
    }

    function lockScroll() {
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.overflow = 'hidden';
      if (scrollbarWidth > 0) document.body.style.paddingRight = scrollbarWidth + 'px';
    }

    function unlockScroll() {
      document.documentElement.style.overflow = '';
      document.body.style.paddingRight = '';
    }

    function openPreview(photo) {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      activePhoto = photo;

      var startRect = photo.getBoundingClientRect();
      img.src = photo.currentSrc || photo.src;
      img.alt = photo.alt || '';

      root.hidden = false;
      lockScroll();

      setImgRect(startRect, false);
      void img.offsetWidth;

      backdrop.style.transition = 'none';
      backdrop.style.opacity = '0';
      void backdrop.offsetWidth;
      backdrop.style.transition = 'opacity ' + PREVIEW_MS + 'ms ' + EASING;
      backdrop.style.opacity = '1';

      animateTo(targetRectFor(photo), PREVIEW_MS);
    }

    function closePreview() {
      if (!activePhoto || root.hidden) return;
      var endRect = activePhoto.getBoundingClientRect();

      backdrop.style.transition = 'opacity ' + PREVIEW_MS + 'ms ' + EASING;
      backdrop.style.opacity = '0';
      animateTo(endRect, PREVIEW_MS);

      unlockScroll();

      var thisPhoto = activePhoto;
      activePhoto = null;
      closeTimer = setTimeout(function () {
        root.hidden = true;
        img.src = '';
        closeTimer = null;
      }, PREVIEW_MS);
    }

    board.querySelectorAll('.os-mood__photo').forEach(function (photo) {
      photo.addEventListener('click', function () {
        openPreview(photo);
      });
    });

    backdrop.addEventListener('click', closePreview);
    img.addEventListener('click', closePreview);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) closePreview();
    });

    window.addEventListener('resize', function () {
      if (activePhoto && !root.hidden) {
        animateTo(targetRectFor(activePhoto), 0);
      }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["os-mp3-player"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-os-mp3]');
    if (!root) return;

    // ---------- Playlist ----------
    // Read from the JSON script tag in the markup above -- not
    // inlined directly here, since Liquid output isn't evaluated
    // inside this script block at all (see that tag's own comment).
    // Add more entries to that JSON array once there's more than one
    // track; skip/restart already loop through it correctly regardless
    // of length.
    var tracksScript = root.querySelector('[data-os-mp3-tracks]');
    var TRACKS = [];
    try {
      TRACKS = JSON.parse(tracksScript.textContent).filter(function (t) {
        return t && t.src;
      });
    } catch (e) {
      TRACKS = [];
    }
    if (!TRACKS.length) return;

    var titlebar = root.querySelector('[data-os-mp3-titlebar]');
    var body = root.querySelector('[data-os-mp3-body]');
    var minimizeBtn = root.querySelector('[data-os-mp3-minimize]');
    var closeBtn = root.querySelector('[data-os-mp3-close]');
    var trackViewport = root.querySelector('[data-os-mp3-track-viewport]');
    var trackTrack = root.querySelector('[data-os-mp3-track-track]');
    var progress = root.querySelector('[data-os-mp3-progress]');
    var progressFill = root.querySelector('[data-os-mp3-progress-fill]');
    var restartBtn = root.querySelector('[data-os-mp3-restart]');
    var playPauseBtn = root.querySelector('[data-os-mp3-playpause]');
    var skipBtn = root.querySelector('[data-os-mp3-skip]');
    var playIcon = root.querySelector('[data-os-mp3-play-icon]');
    var pauseIcon = root.querySelector('[data-os-mp3-pause-icon]');
    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-os-mp3-bar]'));
    var audio = root.querySelector('[data-os-mp3-audio]');
    // audio.volume is LINEAR, but human hearing perceives loudness
    // roughly logarithmically -- 0.5 here previously only sounded like
    // a modest dip, not "half as loud," which is why it still read as
    // too loud even capped. 0.15 is what actually lands as unobtrusive
    // background music rather than a foreground track. This is a
    // ceiling, not a user-facing volume control (there isn't one yet);
    // it still just scales whatever 0-1 value real volume UI would
    // eventually set.
    audio.volume = 0.15;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var trackIndex = 0;

    // ---------- Track title marquee ----------
    // Static and centered when the title fits the screen; only switches
    // into the vending machines' own seamless-loop marquee technique
    // (two copies of the text back to back, animated from
    // translateX(0) to translateX(-50%) -- see .os-gashapon__vending-
    // marquee-track for the original) when the rendered title is wider
    // than the viewport. Measured in real pixels off the actual
    // rendered text, so it adapts to whatever font/zoom is in play
    // rather than guessing from character count.
    var MARQUEE_GAP_PX = 32;
    var MARQUEE_SPEED_PX_S = 20;

    function setTrackTitle(title) {
      trackTrack.classList.remove('is-scrolling');
      trackTrack.style.removeProperty('--marquee-duration');
      trackTrack.innerHTML = '';

      var first = document.createElement('p');
      first.className = 'os-mono os-mp3__track-text';
      first.textContent = title;
      trackTrack.appendChild(first);

      var viewportWidth = trackViewport.clientWidth;
      var textWidth = first.getBoundingClientRect().width;
      if (textWidth <= viewportWidth) return;

      first.style.paddingRight = MARQUEE_GAP_PX + 'px';
      trackTrack.appendChild(first.cloneNode(true));

      var duration = (textWidth + MARQUEE_GAP_PX) / MARQUEE_SPEED_PX_S;
      trackTrack.style.setProperty('--marquee-duration', duration.toFixed(2) + 's');
      trackTrack.classList.add('is-scrolling');
    }

    function loadTrack(index, autoplay) {
      trackIndex = ((index % TRACKS.length) + TRACKS.length) % TRACKS.length;
      var track = TRACKS[trackIndex];
      audio.src = track.src;
      setTrackTitle(track.title);
      progressFill.style.width = '0%';
      if (autoplay) audio.play().catch(function () {});
    }

    // ---------- Cross-page persistence ----------
    // This is a traditional multi-page site (every nav click is a real
    // page load), so the <audio> element itself can't literally keep
    // playing through a navigation -- what this does instead is save
    // exactly where playback was right before the page unloads, then
    // resume from that same track/position once the next page's own
    // copy of this player loads. There's a brief, unavoidable silence
    // during the actual page transition, but it otherwise reads as
    // continuous rather than restarting from track one on every click.
    var STATE_KEY = 'os_mp3_state_v1';

    function saveState() {
      try {
        sessionStorage.setItem(STATE_KEY, JSON.stringify({
          trackIndex: trackIndex,
          currentTime: audio.currentTime,
          wasPlaying: !audio.paused
        }));
      } catch (e) {}
    }

    function readState() {
      try {
        return JSON.parse(sessionStorage.getItem(STATE_KEY));
      } catch (e) {
        return null;
      }
    }

    var savedState = readState();

    // Unhidden before loadTrack runs, not after -- setTrackTitle (called
    // from loadTrack) measures real rendered widths via
    // getBoundingClientRect(), which reads back 0 for anything still
    // inside a display:none subtree ([hidden] is display:none here),
    // and would silently skip the marquee for whatever track loads
    // first. No visible flash from unhiding first: everything between
    // here and the matching paint runs synchronously, so the browser
    // never gets a chance to paint the placeholder in between.
    root.hidden = false;

    if (savedState && TRACKS[savedState.trackIndex]) {
      loadTrack(savedState.trackIndex, false);
      // preload="none" means just setting .src (inside loadTrack) won't
      // actually fetch anything -- normally that's fine since it waits
      // for a real play click, but a restore needs metadata (duration,
      // seekability) up front to place currentTime correctly, so force
      // the fetch explicitly here.
      audio.load();
      audio.addEventListener('loadedmetadata', function onSavedMeta() {
        audio.removeEventListener('loadedmetadata', onSavedMeta);
        audio.currentTime = Math.min(savedState.currentTime || 0, audio.duration || 0);
        if (savedState.wasPlaying) {
          // Not a real click -- Web Audio's own gesture requirement for
          // creating/resuming an AudioContext is independent from the
          // <audio> element's own autoplay permission, so the
          // visualizer may stay idle after an auto-resume like this
          // even though playback itself resumes fine (the browser
          // already considers this origin "engaged" with audio from
          // the earlier real click that started it in the first
          // place). The very next real click anywhere in the player
          // primes the graph properly again.
          audio.play().catch(function () {});
        }
      });
    } else {
      loadTrack(0, false);
    }

    // pagehide rather than beforeunload -- doesn't block the
    // back/forward cache the way beforeunload can in some browsers.
    // The periodic save below is a fallback for any navigation path
    // that skips both (some mobile browsers, some bfcache restores).
    window.addEventListener('pagehide', saveState);
    var lastSavedAt = 0;
    audio.addEventListener('timeupdate', function () {
      var now = Date.now();
      if (now - lastSavedAt > 2000) {
        lastSavedAt = now;
        saveState();
      }
    });

    // ---------- Transport ----------
    function setPlayingUI(isPlaying) {
      playIcon.hidden = isPlaying;
      pauseIcon.hidden = !isPlaying;
      playPauseBtn.setAttribute('aria-pressed', String(isPlaying));
      playPauseBtn.setAttribute('aria-label', isPlaying ? 'Pause' : 'Play');
    }

    playPauseBtn.addEventListener('click', function () {
      if (audio.paused) {
        primeAudioGraph();
        audio.play().catch(function () {});
      } else {
        audio.pause();
      }
    });

    audio.addEventListener('play', function () { setPlayingUI(true); });
    audio.addEventListener('pause', function () { setPlayingUI(false); });

    // Restarts the current track from 0 if it's more than a couple
    // seconds in (matching how real players treat "previous" -- a
    // fresh press near the start of a track goes to the PREVIOUS
    // track instead of just rewinding the one already playing).
    restartBtn.addEventListener('click', function () {
      if (audio.currentTime > 2) {
        audio.currentTime = 0;
      } else {
        loadTrack(trackIndex - 1, !audio.paused);
      }
    });

    skipBtn.addEventListener('click', function () {
      loadTrack(trackIndex + 1, !audio.paused);
    });

    audio.addEventListener('ended', function () {
      loadTrack(trackIndex + 1, true);
    });

    audio.addEventListener('timeupdate', function () {
      if (!audio.duration) return;
      progressFill.style.width = ((audio.currentTime / audio.duration) * 100).toFixed(2) + '%';
    });

    progress.addEventListener('click', function (evt) {
      if (!audio.duration) return;
      var rect = progress.getBoundingClientRect();
      var ratio = Math.min(1, Math.max(0, (evt.clientX - rect.left) / rect.width));
      audio.currentTime = ratio * audio.duration;
    });

    // ---------- Window chrome ----------
    minimizeBtn.addEventListener('click', function () {
      var minimized = root.classList.toggle('is-minimized');
      minimizeBtn.setAttribute('aria-pressed', String(minimized));
    });

    closeBtn.addEventListener('click', function () {
      audio.pause();
      root.hidden = true;
    });

    // ---------- Visualizer ----------
    // 24 bars split into 3 zones of 8 -- low/mid/high slices of the
    // analyser's own frequency-bin array. This is ONE real analyser
    // reading the actual mixed track's spectrum, not truly isolated
    // stems (see this section's own top comment) -- splitting by
    // frequency range is what gives the 3 zones a distinct, layered
    // feel without needing separate stem audio files.
    var audioCtx = null, analyser = null, sourceNode = null, freqData = null;
    var rafId = null;

    function ensureAudioGraph() {
      if (analyser) return;
      try {
        audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        sourceNode = audioCtx.createMediaElementSource(audio);
        analyser = audioCtx.createAnalyser();
        analyser.fftSize = 128;
        analyser.smoothingTimeConstant = 0.75;
        freqData = new Uint8Array(analyser.frequencyBinCount);
        sourceNode.connect(analyser);
        analyser.connect(audioCtx.destination);
      } catch (e) {
        analyser = null;
      }
    }

    // Called synchronously from inside the actual click handler that
    // starts playback, not from the audio element's own (asynchronous)
    // "play" event -- creating/resuming an AudioContext only reliably
    // counts as happening "during" a real user gesture if it's still
    // in the same synchronous call stack as the click itself. Some
    // browsers (Safari especially) are strict enough that doing this
    // from an async event handler instead silently leaves the context
    // suspended, and getByteFrequencyData then just returns all-zero
    // data forever -- no error, the bars just never move off their
    // idle floor.
    function primeAudioGraph() {
      if (reducedMotion) return;
      ensureAudioGraph();
      if (audioCtx && audioCtx.state === 'suspended') audioCtx.resume();
    }

    function renderIdleBars() {
      bars.forEach(function (bar) { bar.style.height = '6%'; });
    }

    function renderBars() {
      if (!analyser) return;
      analyser.getByteFrequencyData(freqData);
      var bins = freqData.length;
      bars.forEach(function (bar, i) {
        var binIndex = Math.floor((i / bars.length) * bins);
        var value = freqData[binIndex] / 255;
        bar.style.height = Math.max(6, value * 100).toFixed(1) + '%';
      });
      rafId = window.requestAnimationFrame(renderBars);
    }

    renderIdleBars();

    audio.addEventListener('play', function () {
      if (reducedMotion) return;
      // The graph itself is primed synchronously from the actual click
      // (see primeAudioGraph above) -- this just starts the per-frame
      // render loop once real playback has begun. Still calls
      // primeAudioGraph as a fallback for any path that starts
      // playback without going through the play/pause button directly
      // (there currently isn't one, but this keeps that assumption
      // from being silently load-bearing).
      primeAudioGraph();
      if (rafId == null) renderBars();
    });

    audio.addEventListener('pause', function () {
      if (rafId != null) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
      }
      renderIdleBars();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["os-nav"]) return;
  try {
    
  (function () {
    var shopToggle = document.querySelector('[data-os-shop-toggle]');
    if (!shopToggle) return;

    var shopPanel = document.getElementById('os-shop-panel');
    var spinner = shopToggle.querySelector('.os-nav-top__spinner');
    var pending = false;

    function closePanel() {
      shopToggle.setAttribute('aria-expanded', 'false');
      shopPanel.hidden = true;
    }

    shopToggle.addEventListener('click', function () {
      if (pending) return;
      pending = true;
      spinner.hidden = false;

      window.setTimeout(function () {
        var expanded = shopToggle.getAttribute('aria-expanded') === 'true';
        var next = !expanded;

        shopToggle.setAttribute('aria-expanded', String(next));
        shopPanel.hidden = !next;
        spinner.hidden = true;
        pending = false;
      }, 900);
    });

    // Picking a link inside the panel closes it immediately, before
    // the click even finishes navigating away — not just relying on
    // the destination page loading fresh-collapsed (see the comment
    // by the markup above), since browser back/forward can restore
    // this exact page from bfcache with whatever DOM state it was
    // left in, bypassing a fresh Liquid render entirely.
    shopPanel.addEventListener('click', function (evt) {
      if (evt.target.closest('a')) closePanel();
    });

    document.addEventListener('click', function (evt) {
      if (shopToggle.getAttribute('aria-expanded') !== 'true') return;
      if (shopToggle.contains(evt.target) || shopPanel.contains(evt.target)) return;
      closePanel();
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && shopToggle.getAttribute('aria-expanded') === 'true') {
        closePanel();
        shopToggle.focus();
      }
    });
  })();

  (function () {
    // Reveal-on-scroll-up, take two. The first version toggled the nav
    // between position: static (a normal in-flow flex item, since
    // <body> is display:flex; flex-direction:column with the header,
    // #MainContent (flex:1), and the footer as its items) and
    // position: fixed (removed from that flex flow entirely) depending
    // on scroll position. Every single toggle changed how much space
    // #MainContent's flex:1 had left to fill — a real, measurable
    // layout shift (confirmed via the PerformanceObserver layout-shift
    // API) every time it happened. Worse, real scroll input isn't
    // perfectly monotonic near the toggle threshold, so it could flap
    // between the two states rapidly, each flap producing another
    // shift — exactly the "jumpy, robotic snapping" reported.
    //
    // The fix: the nav is now ALWAYS position: fixed (see
    // .os-nav-top's base rule) and never rejoins the flex flow, so
    // #MainContent's available space is stable no matter what the nav
    // is doing. Its original in-flow space is reserved instead via
    // padding-top on #MainContent (see --os-nav-h below), which is a
    // pure CSS value, not something toggled per scroll frame.
    var nav = document.querySelector('.os-nav-top');
    if (!nav) return;

    // Cached, not read every scroll frame: offsetHeight forces a
    // synchronous layout. Only recomputed on resize, so the scroll
    // path itself never touches layout, just arithmetic and style
    // writes.
    var headerHeight = nav.offsetHeight;
    var lastScrollY = window.scrollY;
    var revealPx = headerHeight;
    var ticking = false;

    // When the Shop dropdown is open, --os-nav-h needs to reserve its
    // height too — not just the closed nav bar's — so #MainContent's
    // padding-top grows to match and the hero content gets pushed
    // down clear of the floating panel, instead of the panel just
    // overlapping straight onto it. shopPanel is position: absolute
    // (see .os-nav-top__sub), so it never contributes to nav's own
    // offsetHeight on its own — this has to be measured and added in
    // separately, and only while the panel is actually open.
    var shopToggle = document.querySelector('[data-os-shop-toggle]');
    var shopPanel = document.getElementById('os-shop-panel');

    function setHeaderHeightVar() {
      var extra = 0;
      if (shopPanel && !shopPanel.hidden) {
        // The panel's own box plus the gap above it (margin-top on
        // .os-nav-top__sub) is exactly how much further down it
        // reaches past the nav's own bottom edge.
        var panelStyle = getComputedStyle(shopPanel);
        extra = shopPanel.offsetHeight + parseFloat(panelStyle.marginTop || 0);
      }
      document.documentElement.style.setProperty('--os-nav-h', headerHeight + extra + 'px');
    }
    setHeaderHeightVar();

    if (shopToggle && shopPanel) {
      new MutationObserver(setHeaderHeightVar).observe(shopToggle, {
        attributes: true,
        attributeFilter: ['aria-expanded']
      });
    }

    function applyTransform(px) {
      nav.style.transform = 'translateY(' + (px - headerHeight) + 'px)';
    }

    function update() {
      var currentY = Math.max(window.scrollY, 0);
      var delta = currentY - lastScrollY;

      if (currentY <= headerHeight) {
        // Near the top: always fully revealed. No flow/positioning
        // change happens here anymore — just the transform target.
        revealPx = headerHeight;
        applyTransform(revealPx);
        lastScrollY = currentY;
        ticking = false;
        return;
      }

      // Both directions track the scroll 1:1, no separate eased
      // animation for either one — instant, frame-accurate, exactly as
      // far as the scroll itself moved. Hiding used to snap straight to
      // 0 and let a fixed-duration CSS transition ease it out on its
      // own timeline, decoupled from how fast or far the page was
      // actually being scrolled; that read as a different, slower kind
      // of motion than the reveal, which already tracked scroll
      // directly. Deltas in both directions now go through the same
      // clamped subtraction, so hiding moves with the page exactly the
      // same way revealing does.
      revealPx = Math.max(0, Math.min(headerHeight, revealPx - delta));
      applyTransform(revealPx);

      lastScrollY = currentY;
      ticking = false;
    }

    window.addEventListener(
      'resize',
      function () {
        headerHeight = nav.offsetHeight;
        setHeaderHeightVar();
      },
      { passive: true }
    );

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  })();

  (function () {
    var delayLinks = document.querySelectorAll('[data-os-delay-link]');

    delayLinks.forEach(function (link) {
      var spinner = link.querySelector('.os-nav-top__spinner');
      var pending = false;

      link.addEventListener('click', function (evt) {
        if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey || evt.button !== 0) return;
        if (pending) return;

        evt.preventDefault();
        pending = true;
        spinner.hidden = false;

        window.setTimeout(function () {
          window.location.href = link.href;
        }, 900);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
